import * as React from "react";
import Typography from "@mui/material/Typography";
import {
  Button,
  Divider,
  TextField,
  Card,
  Link,
  Box,
  FormControl,
  ButtonGroup,
  Popper,
  Grow,
  ClickAwayListener,
  MenuList,
  MenuItem,
  Paper,
  Alert,
  CircularProgress,
  IconButton,
  CardContent,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Add,
  ArrowDropDown,
  Collections,
  Download,
  Edit,
  LocationOn,
  NoteAdd,
  Visibility,
} from "@mui/icons-material";
import { useParams, useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import JSZip from "jszip";
// @ts-ignore
import * as JSZipUtils from "jszip-utils";
import localize from "../../common/localize";
import useGlobalContext from "../../hooks/useGlobalContext";
import { getInputLabelProps, getInputProps } from "../../common/appStyles";
import DonutChart from "./components/DonutChart";
import ClientInfo from "./components/ClientInfoTable";
import ValueOrNoDataLabel from "../../components/common/ValueOrNoDataLabel";
import {
  generateNoDataValues,
  getOperationalStatusNameFromId,
  getGoogleMapsLink,
  getValueInCurrency,
  getExpectedSolutionDate,
  GetDateInYYYYMMDDWithoutTimeFormat,
  GetDateInYYYYMMDDHHmmss,
  GetDateInYYYYMMDDHHmmssUTCMinus5,
  GetDateInMMDDYYYYFormat,
  getFileExtension,
  getAlertTypeFromOperationalStatusId,
  getEventCode,
  EvidenceUploadStatusEnum,
  GetDateInDDMMYYYYFormat,
  getCurrentDays,
  getDaysToWarning,
  getDaysToError,
  OperationalStatusEnum,
  GeneralStatusEnum,
  getGeneralStatusName,
  getGeneralStatusBackColor,
  getGeneralStatusForeColor,
} from "../../common/utils";
import TableComponent from "../../components/common/TableComponent";
import {
  AdditionalStatusCodeEnum,
  getAdditionalCostStatusBackColor,
  getAdditionalCostStatusForeColor,
  getAdditionalCostStatusName,
  getAdditionalCostsTotalValue,
  getClearAdditionalCostModel,
  getClearBillingModel,
  getClearEventFinishReviewModel,
  getClearEventModel,
  getClearEventPaymentModel,
  getClearEventReviewModel,
  getClearEvidenceModel,
  getClearPaymenttoTechnicianModel,
  getClearSectionModel,
  getClearStatusChangeEventModel,
  getClearSupplyUsageModel,
  getCurrencyFromSetup,
  getEventTotalValue,
  getEvidenceType,
  getNewnessByCode,
  getUserData,
  getUserName,
  isEventDetailTabRestricted,
} from "../../common/EntitiesManagement";
import NoDataLabel from "../../components/common/NoDataLabel";
import ModalBackground from "../../components/common/ModalBackground";
import ErrorMessage from "../../components/common/ErrorMessage";
import StateChangeTimeline from "./components/StateChangeTimeline";
import AddStatusChange from "./components/AddStatusChange";
import ExecutionStatusField from "../../components/common/ExecutionStatusField";
import EventReviewViewer from "./components/EventReviewViewer";
import AddEventReview from "./components/AddEventReview";
import DynamicFormReview from "../dynamicForm/components/review/DynamicFormReview";
import AddOrEditEvidence from "../evidence/components/AddOrEditEvidence";
import {
  createEntity,
  deleteEntity,
  updateEntity,
} from "../../context/GlobalContext";
import DeleteConfirmationMessage from "../../components/common/DeleteConfirmationMessage";
import AddOrEditEvent from "./components/AddOrEditEvent";
import EventSummary from "./components/EventSummary";
import AddBilling from "./components/AddBilling";
import PaymentReport from "./components/PaymentReport";
import FinishEventForm from "./components/FinishEventForm";
import AddOrEditAdditionalCost from "../additionalCosts/AddOrEditAdditionalCost";
import { BackForeColor } from "../../components/common/BackForeColor";
import ReportSetup from "./components/report/Reportsetup";
import PaymentToTechnician from "./components/PaymentToTechnician";
import EventSettlementDetails from "../settlement/components/EventSettlementDetails";
import SetServiceValues from "./components/SetServiceValues";
import EvidenceViewer from "../evidence/components/EvidenceViewer";
import ActionButtons from "../../components/common/ActionButtons";
import AssignEvent from "./components/AssignEvent";
import SupplySearch from "../../components/common/SupplySearch";
import { TabContext, TabPanel } from "@mui/lab";
import ScrollablePageTab from "../dynamicForm/components/ScrollablePageTab";
import ExpandableView from "../../components/common/ExpandableView";
import EventAssignmentModalButton from "./components/EventAssignmentModalButton";
import SupplyRequestStatusChange from "../supplies/components/SupplyRequestStatusChange";
import AddOrEditSection from "../evidence/components/AddOrEditSection";
import WarningErrorStatus from "../../components/common/WarningErrorStatus";
import RequestStatus from "../../components/common/RequestStatus";
import TrueFalseImage from "../../components/TrueFalseImage";
import EventMoneyData from "./components/EventMoneyData";
import EventDataDetails from "./components/EventDataDetails";
import EventClientDatadetails from "./components/EventClientDataDetails";
import TimeDistributionCard from "./components/TimeDistributionCard";
import RegisterSignatureWizard from "./components/RegisterSignatureWizard";
import AddNewness from "./components/AddNewness";

export default function EventDetail() {
  const {
    eventModel,
    setEventModel,
    EVENTS_API,
    GENERAL_REQUESTS_ENDPOINT,
    EVIDENCE_ENDPOINT,
    SETTLEMENT_ENDPOINT,
    config,
    supplyUsageModel,
    setSupplyUsageModel,
    setStatusChangeEventModel,
    toggleVisibleModalConfirm,
    setCity,
    setCityFilterCode,
    setMunicipalityFilterCode,
    PAYMENT_TO_TECHNICIAN_ENDPOINT,
    NEWNESS_ENDPOINT,
    ADDITIONAL_NEWNESS_ENDPOINT,
    userManagementId,
    setPageIndexSupply,
    setShowAssignEventModal,
    showAssignEventModal,
  } = useGlobalContext();
  const [selectedFilesForEvidences, setSelectedFilesForEvidences] = useState(
    [],
  );
  const [notVisibleEvidences, setNotVisibleEvidences] = useState([]);
  const [isUploadingMultipleEvidences, setIsUploadingMultipleEvidences] =
    useState(false);
  const [
    isExecutingMultipleEvidencesUpload,
    setIsExecutingMultipleEvidencesUpload,
  ] = useState(false);
  const [usedWarehouse, setUsedWarehouse] = useState(undefined);
  const [selectedTab, setSelectedTab] = useState("0");
  const [selectedEvidenceTab, setSelectedEvidenceTab] = useState("0");
  const [selectedTabId, setSelectedTabId] = useState(0);
  const [selectedEvidenceTabId, setSelectedEvidenceTabId] = useState(0);
  const [openEventOptions, setOpenEventOptions] = useState(false);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(0);
  const [showRegisterSignatureModal, setShowRegisterSignatureModal] =
    useState(false);
  const [supplyUsageEditionModel, setSupplyUsageEditionModel] = useState();
  const [
    showSupplyUsageStatusChangeModal,
    setShowSupplyUsageStatusChangeModal,
  ] = useState(false);
  const anchorOptionsRef = React.useRef(null);
  const maximumCharactersForSupplyUsageDescription = 255;
  const [
    detailSupplyUsageObservationCount,
    setDetailSupplyUsageObservationCount,
  ] = useState(0);
  const [detailSupplyUsageObservation, setDetailSupplyUsageObservation] =
    useState("");

  const [isDownloadingEvidences, setIsDownloadingEvidences] = useState(false);
  const [selectedEvidence, setSelectedEvidence] = useState();
  const [showGenerateInformModal, setShowGenerateInformModal] = useState(false);
  const [eventDetailData, setEventDetailData] = useState();
  const [supplyData, setSupplyData] = useState({});
  const [newnessData, setNewnessData] = useState({});
  const [evidenceData, setEvidenceData] = useState({});
  const [statusChangeData, setStatusChangeData] = useState({});
  const [statisticsData, setStatisticsData] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageTitle, setErrorMessageTitle] = useState();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showAddSupplyModal, setShowAddSupplyModal] = useState(false);
  const [showSupplySearchModal, setShowSupplySearchModal] = useState(false);
  const [showAddStatusChangeModal, setShowAddStatusChangeModal] =
    useState(false);
  const [showAddNewnessModal, setShowAddNewnessModal] = useState(false);
  const [showAddNewnessSuccess, setShowAddNewnessSuccess] = useState(false);
  const [additionalNewnessOptions, setAdditionalNewnessOptions] = useState([]);
  const [newnessModel, setNewnessModel] = useState({
    AdditionalNewness: null,
    AdditionalNewnessId: 0,
    Observation: "",
  });
  const [showPaymentToTechnicianModal, setShowPaymentToTechnicianModal] =
    useState(false);
  const [paymentToTechnician, setPaymentToTechnician] = useState(
    getClearPaymenttoTechnicianModel(),
  );
  const [paymentsToTechnician, setPaymentsToTechnician] = useState(
    getClearPaymenttoTechnicianModel(),
  );
  const [showGalleryModal, setShowModalGallery] = useState(false);
  const [eventSettlements, setEventSettlements] = useState([]);
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const tabId = searchParams.get("tab_id");
    if (tabId) {
      setSelectedTab(tabId);
      setSelectedTabId(parseInt(tabId));
    }
  }, [searchParams]);

  // If the selected tab is hidden by RBAC tab-visibility, fall back to the
  // first visible tab so no restricted panel renders (incl. ?tab_id deep-links).
  useEffect(() => {
    const visiblePages = getTabPages();
    if (
      visiblePages.length > 0 &&
      !visiblePages.some((page) => page.Id === selectedTabId)
    ) {
      changeTab(visiblePages[0].Id);
    }
  }, [eventDetailData, selectedTabId]);
  const [newStatus, setNewStatus] = useState();
  const [supplyItemToDelete, setSupplyItemToDelete] = useState();
  const [
    showSupplyItemDeleteConfirmation,
    setShowSupplyItemDeleteConfirmation,
  ] = useState();
  const [dynamicFormForReview, setDynamicFormForReview] = useState(undefined);
  const [evidenceModelForEdition, setEvidenceModelForEdition] = useState(null);
  const [showEvidenceModal, setShowEvidenceModal] = useState(false);
  const [showFinishReview, setShowFinishReview] = useState(false);
  const [finishEventReview, setFinishEventReview] = useState(null);
  const [eventReviewData, setEventReviewData] = useState(null);
  const [eventReview, setEventReview] = useState(null);
  const [showAddEventReview, setShowAddEventReview] = useState(false);
  const [eventResolutionsData, setEventResolutionsData] = useState(null);
  const [showUploadingImage, setShowUploadingImage] = useState(false);
  const [updateEvidenceFile, setUpdateEvidenceFile] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteSectionModal, setShowDeleteSectionModal] = useState(false);
  const [showCreateVisit, setShowCreateVisit] = useState(false);
  const [showModalAfterEventCreation, setShowModalAfterEventCreation] =
    useState(false);
  const [newEventId, setNewEventId] = useState(0);
  const [showServiceValuesModal, setShowServiceValuesModal] = useState(false);
  const [showEventSummary, setShowEventSummary] = useState(false);
  const [showEventBilling, setShowEventBilling] = useState(false);
  const [showEventPayment, setShowEventPayment] = useState(false);
  const [eventDetailValues, setEventDetailValues] = useState({});
  const [eventPaymentData, setEventPaymentData] = useState(
    getClearEventPaymentModel(),
  );
  const [showSuccessNotification, setShowSuccessNotification] = useState(false);
  const [successNotificationMessage, setSuccessNotificationMessage] =
    useState("");
  const [showSettlementRequestConfirm, setShowSettlementRequestConfirm] =
    useState(false);
  const [showSettlementRequestSuccess, setShowSettlementRequestSuccess] =
    useState(false);
  const [settlementRequesting, setSettlementRequesting] = useState(false);
  const [eventBillingModel, setEventBillingModel] = useState(
    getClearBillingModel(id),
  );
  const [showAdditionalCostsModal, setShowAdditionalCostsModal] =
    useState(false);
  const [additionalCostModel, setAdditionalCostModel] = useState(
    getClearAdditionalCostModel(id),
  );
  const [assignAdditionalCostStatus, setAssignAdditionalCostStatus] =
    useState(false);
  const [additionalCosts, setAdditionalCosts] = useState([]);
  const [searchSupplyList, setSearchSupplyList] = useState([]);
  const [quantityForSupply, setQuantityForSupply] = useState(1);
  const [showSectionForm, setShowSectionForm] = useState(false);
  const [sectionModel, setSectionModel] = useState(getClearSectionModel(id));
  const [evidencesSections, setEvidencesSections] = useState([]);
  const [generalRequests, setGeneralRequests] = useState([]);
  const getAdditionalCostValue = () =>
    getAdditionalCostsTotalValue(additionalCosts.Data);

  const eventAlreadyFinished = () => eventDetailData?.CanEdit === 0;

  const isEvidenceInvisible = (evidenceId) => {
    return notVisibleEvidences && notVisibleEvidences.includes(evidenceId);
  };

  const ToggleEvidenceVisibility = (evidenceId) => {
    const currentlyInvisible = isEvidenceInvisible(evidenceId);
    let newNotVisibleEvidences = [];
    if (currentlyInvisible) {
      newNotVisibleEvidences = notVisibleEvidences.filter(
        (id) => id !== evidenceId,
      );
    } else {
      newNotVisibleEvidences = [...(notVisibleEvidences || []), evidenceId];
    }
    setNotVisibleEvidences(newNotVisibleEvidences);
  };

  const getEventResolutions = async () => {
    const requestConfig = {
      ...config,
    };
    requestConfig.headers.pagination = -1;
    const data = await axios.get(
      `${EVENTS_API}/${id}/resolution`,
      requestConfig,
    );

    setEventResolutionsData(data?.data?.Data);
  };

  useEffect(() => {
    getEventResolutions();
    getEventReviews();
  }, []);

  const getEventReviews = async () => {
    const requestConfig = {
      ...config,
    };
    requestConfig.headers.pagination = -1;
    const data = await axios.get(`${EVENTS_API}/${id}/review`, requestConfig);

    setEventReviewData(data?.data);
  };

  const canEditEventInformation = () => eventDetailData?.CanEdit === 1;

  const handleAssignRequest = async (data) => {
    const updateResult = await updateEntity(
      `${`${EVENTS_API}/${data.Id}/assign`}`,
      { ...data, AssignedBy: getUserData()?.UserName },
      config,
    );

    if (!updateResult.ok) {
      setShowAssignEventModal(false);
      setErrorMessage(JSON.stringify(updateResult.data));
      setShowErrorModal(true);
      return;
    }

    window.location.reload(false);
    showUpdateMessage();
  };

  const validateOperationResult = (result) => {
    setShowUploadingImage(false);
    if (!result.ok && !result.Ok) {
      setErrorMessage(
        JSON.stringify(result?.data || result?.Data || result?.error),
      );
      setShowErrorModal(true);
      return false;
    }

    return true;
  };

  const validateCreationResult = (result) => {
    if (!result.ok) {
      setErrorMessage(
        JSON.stringify(result?.data || result?.Data || result?.error),
      );
      setShowErrorModal(true);
      return;
    }

    if (result.data > 0) {
      setNewEventId(result.data);
      setShowModalAfterEventCreation(true);
      showUpdateMessage();
    }
  };

  const validateOperationResultRaw = (result) => {
    if (!result?.Ok && !result?.ok) {
      setErrorMessage(
        !result?.data && !result?.Data
          ? localize.error_unexpected
          : JSON.stringify(result?.data || result?.Data),
      );
      setShowErrorModal(true);
      return false;
    }

    return true;
  };

  const getSupplies = async () => {
    try {
      const data = await axios.get(`${EVENTS_API}/${id}/supply-usage`, config);
      validateOperationResultRaw(data.data);
      setSupplyData(data.data);
    } catch (error) {
      validateOperationResult(error.response.data);
    }
  };

  const createSupply = async (supplyUsageToCreate) => {
    try {
      const modelToSend = {
        ...supplyUsageToCreate,
        EventId: id,
        WarehouseId: usedWarehouse?.Id,
      };
      const data = await axios.post(
        `${EVENTS_API}/${id}/supply-usage`,
        modelToSend,
        config,
      );
      if (validateOperationResultRaw(data.data)) {
        window.location.href = `/events/detail/${id}?tab_id=5`;
        return;
      }
    } catch (error) {
      validateOperationResult(error.response.data);
      setSearchSupplyList([]);
    }
  };

  const deleteSupply = async (supplyItem) => {
    try {
      const data = await axios.delete(
        `${EVENTS_API}/${id}/supply-usage/${supplyItem.Id}`,
        config,
      );
      validateOperationResultRaw(data.data);
      await getSupplies();
      showUpdateMessage();
    } catch (error) {
      validateOperationResult(error.response.data);
    } finally {
      setSupplyItemToDelete(null);
    }
  };

  const getStatistics = async () => {
    try {
      const data = await axios.get(`${EVENTS_API}/${id}/statistics`, config);
      validateOperationResultRaw(data.data);
      setStatisticsData(data.data);
    } catch (error) {
      validateOperationResult(error.response.data);
    }
  };

  const getStatusChanges = async () => {
    try {
      const data = await axios.get(`${EVENTS_API}/${id}/status-change`, config);
      validateOperationResultRaw(data.data);
      setStatusChangeData(data.data);
    } catch (error) {
      validateOperationResult(error.response.data);
    }
  };

  const getAdditionalCosts = async () => {
    try {
      const data = await axios.get(
        `${EVENTS_API}/${id}/additionalCost`,
        config,
      );

      validateOperationResultRaw(data.data);
      setAdditionalCosts(data.data);
    } catch (error) {
      validateOperationResult(error.response.data);
    }
  };

  const createStatusChange = async () => {
    try {
      const statusChange = {
        ...getClearStatusChangeEventModel(),
        DynamicFormId: newStatus.DynamicForm ? newStatus.DynamicForm.Id : 0,
        InitialStatusId: newStatus.InitialStatus.Id,
        FinalStatusId: newStatus.FinalStatus.Id,
        Observation: newStatus.Observation,
      };

      const data = await axios.post(
        `${EVENTS_API}/${id}/status-change`,
        { EventId: id, ...statusChange },
        config,
      );

      validateOperationResultRaw(data.data);
      setEventDetailData({
        ...eventDetailData,
        OperationalStatus: newStatus.FinalStatus.OperationalStatus,
        CurrentStatus: newStatus.FinalStatus,
      });
      await getStatusChanges();
      showUpdateMessage();
    } catch (error) {
      validateOperationResult(error.response.data);
    } finally {
      setNewStatus({});
      setShowAddStatusChangeModal(false);
    }
  };

  const getNewnesses = async () => {
    try {
      const data = await axios.get(`${EVENTS_API}/${id}/newness`, config);
      validateOperationResultRaw(data.data);
      setNewnessData(data.data);
    } catch (error) {
      validateOperationResult(error.response.data);
    }
  };

  const getAdditionalNewnessOptions = async () => {
    try {
      const requestConfig = { ...config };
      requestConfig.headers.pagination = -1;
      const data = await axios.get(
        `${ADDITIONAL_NEWNESS_ENDPOINT}`,
        requestConfig,
      );
      setAdditionalNewnessOptions(data?.data?.Data ?? []);
    } catch (error) {
      setAdditionalNewnessOptions([]);
    }
  };

  useEffect(() => {
    getAdditionalNewnessOptions();
  }, []);

  const disableSaveNewness = () => {
    const selected = newnessModel?.AdditionalNewness;
    if (!selected || !(selected.Id > 0)) {
      return true;
    }
    if (
      selected.NeedObservation &&
      (!newnessModel?.Observation ||
        newnessModel.Observation.trim().length === 0)
    ) {
      return true;
    }
    return false;
  };

  const createNewness = async () => {
    const body = {
      Code: "",
      AdditionalNewnessId: newnessModel?.AdditionalNewness?.Id,
      EventId: id,
      Observation: newnessModel?.Observation,
      OccurTime: GetDateInYYYYMMDDHHmmssUTCMinus5(new Date()),
      CreatedBy: getUserName(),
      managementId: userManagementId,
    };
    const result = await createEntity(`${NEWNESS_ENDPOINT}`, body, config);
    if (validateOperationResult(result)) {
      setShowAddNewnessModal(false);
      setShowAddNewnessSuccess(true);
    }
  };

  const getEvidences = async () => {
    try {
      const data = await axios.get(`${EVENTS_API}/${id}/evidence`, config);
      validateOperationResultRaw(data.data);
      setEvidenceData(data.data);
    } catch (error) {
      validateOperationResult(error.response.data);
    }
  };

  function createData(fieldName, fieldValue, fieldType, editFunction) {
    return { fieldName, fieldValue, fieldType, editFunction };
  }

  const createEventPaymentData = () => {
    const result = [];

    result.push(
      createData(
        localize.status,
        !eventDetailData?.Payed ? localize.not_payed : localize.payed,
        "PaymentStatus",
      ),
    );

    if (eventDetailData?.Payed) {
      result.push(
        createData(
          localize.payment_method,
          eventDetailData?.PaymentMethod?.Name,
          "PaymentMethod",
        ),
      );
    }

    result.push(
      createData(
        eventDetailData?.Payed ? localize.payment_date : localize.observations,
        eventDetailData?.Payed
          ? GetDateInMMDDYYYYFormat(new Date(eventDetailData.PaymentDate))
          : eventDetailData?.NoPaymentObservation,
        "PaymentDateOrObservation",
      ),
    );

    return result;
  };

  const billingData = [
    createData(
      localize.bill_code,
      eventDetailData?.Bill?.Billed ? (
        eventDetailData?.Bill?.Id ? (
          <Link
            color="primary"
            underline="always"
            href="#"
            onClick={() => {
              window.open(`/bills/${eventDetailData.Bill.Id}`, "_blank");
            }}
          >
            {eventDetailData?.Bill?.Code}
          </Link>
        ) : (
          eventDetailData?.Bill?.Code
        )
      ) : (
        localize.not_billed
      ),
      "BillCode",
    ),
    createData(
      eventDetailData?.Bill?.Billed
        ? localize.bill_date
        : localize.observations,
      eventDetailData?.Bill?.Billed
        ? eventDetailData?.Bill?.GenerationDate
          ? GetDateInMMDDYYYYFormat(
              new Date(eventDetailData?.Bill?.GenerationDate),
            )
          : localize.no_data
        : eventDetailData?.Bill?.Observation,
      "BillGenerationDate",
    ),
  ];

  const obtainsEventData = async (eventId) => {
    const eventData = await axios.get(`${EVENTS_API}/${eventId}`, config);
    const event = eventData?.data?.Data;
    setEventDetailValues({
      sparePartsFinalValue: event?.sparePartsFinalValue,
      sparePartsRealValue: event?.sparePartsRealValue,
      executionFinalValue: event?.executionFinalValue,
    });
    setEventDetailData(event);
  };

  const showUpdateMessage = () => {
    setSuccessNotificationMessage(localize.service_order_updated);
    setShowSuccessNotification(true);
  };

  const UpdateServiceValues = async () => {
    const updateServiceResult = await updateEntity(
      `${`${EVENTS_API}/${eventDetailData.Id}/serviceValues`}`,
      {
        executionFinalValue: eventDetailValues.executionFinalValue,
        sparePartsFinalValue: eventDetailValues.sparePartsFinalValue,
        sparePartsRealValue: eventDetailValues.sparePartsRealValue,
      },
      config,
    );

    if (validateOperationResult(updateServiceResult, false)) {
      obtainsEventData(eventDetailData.Id);

      showUpdateMessage();
    }
  };

  const assignEventValues = () => {
    setShowServiceValuesModal(true);
  };

  const assignedPersonalOrAssignmentButton = () => {
    if (eventDetailData?.PersonalAssigned) {
      if (canEditEventInformation()) {
        return (
          <EventAssignmentModalButton
            eventDetailData={eventDetailData}
            setEventModel={setEventModel}
            setShowAssignEventModal={setShowAssignEventModal}
          />
        );
      }

      return (
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {`${eventDetailData.PersonalAssigned.SurName} ${eventDetailData.PersonalAssigned.LastName}`}
        </Typography>
      );
    }

    if (eventAlreadyFinished()) {
      return (
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {localize.no_data}
        </Typography>
      );
    }

    return (
      <button
        className="not_assigned_label rounded p-2"
        onClick={() => {
          setEventModel({
            ...eventDetailData,
            StateId: eventDetailData.State.Id,
            CityId: eventDetailData.City.Id,
            TeamId: eventDetailData.AssignedTeam?.Id,
            EventTypeId: eventDetailData.EventType?.Id,
            ClientId: eventDetailData.Client?.Id,
            StatusId: eventDetailData.CurrentStatus?.Id,
            ExpectedSolutionDateValue: !eventDetailData?.ExpectedSolutionDate
              ? null
              : new Date(eventDetailData?.ExpectedSolutionDate),
            ExpectedSolutionDate: eventDetailData?.ExpectedSolutionDate,
            ExpectedSolutionFinalDateValue:
              !eventDetailData?.ExpectedSolutionFinalDate
                ? null
                : new Date(eventDetailData?.ExpectedSolutionFinalDate),
            ExpectedSolutionFinalDate:
              eventDetailData?.ExpectedSolutionFinalDate,
            PersonalId: eventDetailData.PersonalAssigned?.id,
            VehicleId: eventDetailData.VehicleAssigned?.Id,
            ProceedingId: eventDetailData.ProceedingInfo?.Id,
          });
          setShowAssignEventModal(true);
        }}
      >
        {localize.assign}
      </button>
    );
  };

  const clientInfoData = [
    createData(
      localize.identification_type,
      eventDetailData?.Client?.IdentificationType,
    ),
    createData(
      localize.identification,
      eventDetailData?.Client?.Identification,
    ),
    createData(localize.name, eventDetailData?.Client?.Name),
    createData(localize.phone_number, eventDetailData?.Client?.PhoneNumber),
    createData(localize.email, eventDetailData?.Client?.Email),
    createData(
      localize.address,
      eventDetailData?.Client?.Address
        ? `${eventDetailData?.Client?.Address} ${
            eventDetailData?.Client?.AddressComplement ?? ""
          }`
        : eventDetailData?.Client?.AddressComplement,
    ),
    createData(localize.department, eventDetailData?.Client?.State?.Name),
    createData(localize.city, eventDetailData?.Client?.City?.Name),
    createData(localize.contact_name, eventDetailData?.Client?.ContactName),
  ];

  const generateAdditionalDataInfo = (data) => {
    if (data && data.length > 0) {
      const parsed = JSON.parse(data);

      const dataArray = parsed.map((x) => createData(x.name, x.value));
      return dataArray;
    }

    return [];
  };

  const getNewnessDescription = (newness) => {
    if (newness?.AdditionalNewness) {
      return newness?.AdditionalNewness.Name;
    }
    return getNewnessByCode(newness.Code);
  };

  const downloadZipFile = (blob, fileName) => {
    // Create a link element
    const link = document.createElement("a");

    // Set link's href to point to the Blob URL
    link.href = blob;
    link.download = `${fileName}.zip`;

    // Append link to the body
    document.body.appendChild(link);

    // Dispatch click event on the link
    // This is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      }),
    );

    // Remove link from body
    document.body.removeChild(link);
  };

  const downloadEvidence = async (selectedEvidence) => {
    let urlBlob = "";

    await axios({
      ...config,
      method: "get",
      responseType: "blob", // Force to receive data in a Blob Format
      url: `${EVENTS_API}/${id}/evidence/${selectedEvidence.Id}/download`,
    })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/octet-stream",
        });

        urlBlob = URL.createObjectURL(blob);
      })
      .catch((error) => {
        setErrorMessage(error.message);
        setShowErrorModal(true);
      });

    if (urlBlob.length > 0) {
      // Create a link element
      const link = document.createElement("a");

      // Set link's href to point to the Blob URL
      link.href = urlBlob;
      link.download = `${selectedEvidence.Name.replace(
        " ",
        "_",
      )}.${getFileExtension(selectedEvidence.Path)}`;

      // Append link to the body
      document.body.appendChild(link);

      // Dispatch click event on the link
      // This is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        }),
      );

      // Remove link from body
      document.body.removeChild(link);
    }
  };

  const downloadEvidences = async (eventId, evidences, eventCode) => {
    try {
      setIsDownloadingEvidences(true);

      var zip = new JSZip();
      var count = 0;
      var evidencesUrls = evidences.map((x) => ({
        Name: `${x.Name.replace(" ", "_")}.${getFileExtension(x.Path)}`,
        Path: `${EVENTS_API}/${eventId}/evidence/${x.Id}/download`,
      }));

      evidencesUrls.forEach(async (evidenceUrl) => {
        await axios({
          ...config,
          method: "get",
          responseType: "blob", // Force to receive data in a Blob Format
          url: evidenceUrl.Path,
        })
          .then((res) => {
            const blob = new Blob([res.data], {
              type: "application/octet-stream",
            });

            const urlBlob = URL.createObjectURL(blob);
            JSZipUtils.getBinaryContent(urlBlob, function (err, data) {
              if (err) {
                throw err; // or handle the error
              }
              zip.file(evidenceUrl.Name, data, { binary: true });
              count++;
              if (count === evidencesUrls.length) {
                zip.generateAsync({ type: "blob" }).then(function (content) {
                  downloadZipFile(URL.createObjectURL(content), eventCode);
                });
                setIsDownloadingEvidences(false);
              }
            });
          })
          .catch((error) => {
            throw error; // or handle the error
          });
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getPaymentToTechnicianInfo = async (eventId) => {
    const paymentInfo = await axios.get(
      `${EVENTS_API}/${eventId}/paymentToTechnician`,
      config,
    );
    setPaymentsToTechnician(paymentInfo?.data?.Data);
  };

  const getEventSettlements = async (eventId) => {
    try {
      const data = await axios.get(
        `${EVENTS_API}/${eventId}/settlement`,
        config,
      );
      const body = data?.data;
      setEventSettlements(Array.isArray(body) ? body : (body?.Data ?? []));
    } catch {
      setEventSettlements([]);
    }
  };

  const getEventData = async (eventId) => {
    await obtainsEventData(eventId);

    Promise.all([
      getSupplies(),
      getNewnesses(),
      getEvidences(),
      getStatusChanges(),
      getStatistics(),
      getAdditionalCosts(),
      getPaymentToTechnicianInfo(eventId),
      getEvidencesSections(),
      getGeneralRequestByEvent(),
      getEventSettlements(eventId),
    ]);
  };

  useEffect(() => {
    if (id) {
      getEventData(id);
    }
  }, [id]);

  const showExecutionTime = () => {
    if (statisticsData?.Data && statisticsData.Data?.timeElapsed) {
      const { timeElapsed } = statisticsData.Data;
      return `${localize.total}: ${timeElapsed.days} ${localize.days}, ${timeElapsed.hours} ${localize.hours}, ${timeElapsed.minutes} ${localize.minutes}, ${timeElapsed.seconds} ${localize.seconds}`;
    }

    return localize.execution_times_description;
  };

  const finishButtonMustBeAvailable = () =>
    eventDetailData?.OperationalStatus === 3 ||
    eventDetailData?.OperationalStatus === 4 ||
    eventDetailData?.OperationalStatus === 0 ||
    eventDetailData?.OperationalStatus === 5;

  const getCode = () => {
    return getEventCode(eventDetailData);
  };

  const createEventReview = async () => {
    try {
      const response =
        eventReview.Id > 0
          ? await axios.put(
              `${EVENTS_API}/${eventDetailData?.Id}/review/${eventReview.Id}`,
              eventReview,
              config,
            )
          : await axios.post(
              `${EVENTS_API}/${eventDetailData?.Id}/review`,
              eventReview,
              config,
            );
      validateOperationResultRaw(response?.data, false);
      if (response?.data?.Ok) {
        await getEventReviews();
        showUpdateMessage();
      }
    } catch (error) {
      validateOperationResult(error.response.data);
    } finally {
      setShowAddEventReview(false);
      setEventReview(null);
    }
  };

  const finishReview = async () => {
    try {
      const response = await axios.post(
        `${EVENTS_API}/${eventDetailData?.Id}/finish`,
        finishEventReview,
        config,
      );

      validateOperationResultRaw(response?.data, false);
      if (response?.data?.Ok) {
        showUpdateMessage();
        window.location.reload(true);
      }
    } catch (error) {
      validateOperationResult(error.response.data);
    } finally {
      setShowFinishReview(false);
    }
  };

  const validateOperationResultForFileUpload = async (
    result,
    hideNotification,
    getSections = false,
  ) => {
    setShowUploadingImage(false);

    if (!result.Ok && !result.ok) {
      setErrorMessage(result.Data || result.data || result.error);
      setShowErrorModal(true);
      return;
    }

    await getEvidences();

    if (getSections) {
      await getEvidencesSections();
    }

    if (!hideNotification) {
      showUpdateMessage();
    }
  };

  const handleCreateOrUpdateEvidence = async (evidence) => {
    if (!evidence) {
      return;
    }

    const fileToUpload = evidence.File;
    setEvidenceModelForEdition({
      ...evidence,
      CreatedBy: getUserData()?.UserName,
      File: null,
    });

    if (!updateEvidenceFile || !fileToUpload) {
      updateEvidenceName(evidenceModelForEdition);
      return;
    }

    setShowUploadingImage(true);
    const fileUploadResult = await fileUpload(
      evidence?.Id,
      fileToUpload,
      evidenceModelForEdition,
    );
    validateOperationResultForFileUpload(fileUploadResult, false);
  };

  const updateEvidenceName = async (evidence) => {
    const updateResult = await updateEntity(
      `${EVIDENCE_ENDPOINT}/${evidence.Id}/name`,
      evidence,
      config,
    );

    validateOperationResultForFileUpload(updateResult, true);
  };

  const fileUpload = async (evidenceId, file, fieldValue) => {
    const url =
      evidenceId > 0
        ? `${EVIDENCE_ENDPOINT}/${evidenceId}`
        : `${EVIDENCE_ENDPOINT}`;
    const formData = new FormData();
    formData.append(
      "requestData",
      new Blob([JSON.stringify(fieldValue)], {
        type: "application/json",
      }),
    );
    formData.append("document", file, file.name);

    const requestConfig = {
      ...config,
      headers: {
        ...config.headers,
        "Content-Type": undefined,
      },
    };

    try {
      const requestResult =
        evidenceId > 0
          ? await axios.put(url, formData, requestConfig)
          : await axios.post(url, formData, requestConfig);

      return requestResult?.data;
    } catch (error) {
      return { Ok: false, Data: error.message };
    }
  };

  const deleteSection = async (section) => {
    const deleteResult = await deleteEntity(
      `${EVENTS_API}/${eventDetailData?.Id}/evidence-section/${section?.Id}`,
      config,
    );
    validateOperationResultForFileUpload(deleteResult, false, true);
  };

  const deleteEvidence = async (evidence) => {
    const deleteResult = await deleteEntity(
      `${EVIDENCE_ENDPOINT}/${evidence?.Id}`,
      config,
    );
    validateOperationResultForFileUpload(deleteResult, false);
  };

  const handleCreateRequest = async (data) => {
    const updateResult = await createEntity(`${`${EVENTS_API}`}`, data, config);
    validateCreationResult(updateResult);
  };

  const handleCreateAdditionalCost = async (data) => {
    const creationResult = await createEntity(
      `${`${EVENTS_API}/${eventDetailData?.Id}/additionalCost`}`,
      data,
      config,
    );

    if (validateOperationResult(creationResult)) {
      await getAdditionalCosts();
      showUpdateMessage();
    }
  };

  const handleUpdateAdditionalCost = async (data) => {
    const creationResult = await updateEntity(
      `${`${EVENTS_API}/${eventDetailData?.Id}/additionalCost/${additionalCostModel.Id}`}`,
      data,
      config,
    );

    if (validateOperationResult(creationResult)) {
      await getAdditionalCosts();
      showUpdateMessage();
    }
  };

  const UpdatePaymentDate = async () => {
    try {
      const paymentData = {
        ...eventPaymentData,
        PaymentDate: GetDateInYYYYMMDDWithoutTimeFormat(
          eventPaymentData.PaymentDate,
        ),
      };
      const data = await axios.put(
        `${EVENTS_API}/${id}/payment`,
        paymentData,
        config,
      );

      if (validateOperationResultRaw(data.data)) {
        setEventDetailData({
          ...eventDetailData,
          PaymentDate: paymentData.PaymentDate,
          Payed: paymentData.Payed,
          NoPaymentObservation: paymentData.NoPaymentObservation,
          PaymentMethod: eventPaymentData.PaymentMethod,
        });
        setSuccessNotificationMessage(localize.payment_data_udpated);
        setShowEventPayment(false);
        setShowSuccessNotification(true);
      }
    } catch (error) {
      validateOperationResult(error.response.data);
    } finally {
      setEventPaymentData(getClearEventPaymentModel());
    }
  };

  const RegisterBilling = async () => {
    try {
      const billingModel = {
        ...eventBillingModel,
        EventId: [id],
        GenerationDate: eventBillingModel.Billed
          ? GetDateInYYYYMMDDWithoutTimeFormat(eventBillingModel.GenerationDate)
          : null,
      };

      const data = await axios.post(
        `${EVENTS_API}/${id}/bill`,
        billingModel,
        config,
      );

      if (validateOperationResultRaw(data.data)) {
        setEventDetailData({
          ...eventDetailData,
          Bill: billingModel,
        });
        setSuccessNotificationMessage(localize.bill_registered_successfully);
        setShowEventBilling(false);
        setShowSuccessNotification(true);
      }
    } catch (error) {
      validateOperationResult(error.response.data);
    }
  };

  const RegisterPaymentToTechnician = async () => {
    try {
      let data = undefined;

      if (paymentToTechnician?.Id > 0) {
        data = await axios.put(
              `${PAYMENT_TO_TECHNICIAN_ENDPOINT}/${paymentToTechnician.Id}`,
              { ...paymentToTechnician, EventId: eventDetailData?.Id },
              config,
            );
      }
      else{
        data = await axios.post(
              `${PAYMENT_TO_TECHNICIAN_ENDPOINT}`,
              paymentToTechnician,
              config,
            );
      }

      if (validateOperationResultRaw(data?.data)) {
        await obtainsEventData(eventDetailData?.Id);
        getPaymentToTechnicianInfo(eventDetailData?.Id);

        setSuccessNotificationMessage(
          paymentToTechnician?.Id > 0
            ? localize.service_order_updated
            : localize.payment_registered_successfully,
        );
        setShowPaymentToTechnicianModal(false);
        setShowSuccessNotification(true);
      }
    } catch (error) {
      validateOperationResult(error.response.data);
    }
  };

  const getTotalPaymentToTechnician = (payments) => {
    /* eslint-disable no-param-reassign */
    const totalValue = payments.reduce(
      (a, v) => (a += v.Status === GeneralStatusEnum.Approved ? v.Value : 0),
      0,
    );
    return getValueInCurrency(getCurrencyFromSetup(), totalValue);
  };

  const deleteSupplyItem = (supplyItem) => {
    deleteSupply(supplyItem);
  };

  const confirmSupplyDelete = (supplyItem) => {
    setSupplyItemToDelete(supplyItem);
    setShowSupplyItemDeleteConfirmation(true);
    toggleVisibleModalConfirm();
  };

  const canDeleteSupplyUsage = (usage) =>
    usage?.Status === AdditionalStatusCodeEnum.InProgress;

  const generateSupplyTableData = (item) => {
    const tableData = [];

    if (canEditEventInformation()) {
      tableData.push(
        <ActionButtons
          hideEditButton={!canDeleteSupplyUsage(item)}
          onClickForEditButton={() => {
            setSupplyUsageEditionModel({
              ...item,
              SelectedStatus: {
                Id: item.Status,
                Name: getAdditionalCostStatusName(item.Status),
              },
            });
            setShowSupplyUsageStatusChangeModal(true);
          }}
          onclickForDeleteButton={() => {
            confirmSupplyDelete(item);
          }}
          disabled={!canDeleteSupplyUsage(item)}
        />,
      );
    }

    tableData.push(
      ...[
        item?.Quantity ?? 0,
        <ValueOrNoDataLabel
          data={`[${item?.SupplyData?.Code}] ${item?.SupplyData?.Name}`}
        />,
        <ValueOrNoDataLabel
          data={
            item.SupplyData?.Unit?.Symbol &&
            item.SupplyData?.Unit?.Symbol !== ""
              ? `${item.SupplyData?.Unit?.Name} (${item.SupplyData?.Unit?.Symbol})`
              : `${item.SupplyData?.Unit?.Name}`
          }
        />,
        <BackForeColor
          backColor={getAdditionalCostStatusBackColor(item.Status)}
          foreColor={getAdditionalCostStatusForeColor(item.Status)}
          text={getAdditionalCostStatusName(item.Status)}
        />,
        <ValueOrNoDataLabel data={item?.Warehouse?.Name} />,
        <ValueOrNoDataLabel
          data={
            item?.Observation || item?.StatusObservation
              ? `${item?.Observation ?? ""}${
                  item?.StatusObservation
                    ? `${
                        item?.Observation
                          ? `. ${getAdditionalCostStatusName(
                              item?.Status,
                            ).toUpperCase()}: ${item?.StatusObservation}`
                          : `${getAdditionalCostStatusName(
                              item?.Status,
                            ).toUpperCase()}: ${item?.StatusObservation}`
                      }`
                    : ""
                }`
              : undefined
          }
        />,
        <ValueOrNoDataLabel data={item?.CreatedBy} />,
      ],
    );

    return tableData;
  };

  const showEditReview = (item) => {
    if (!item) {
      return;
    }

    if (item.Evidence) {
      setEventReview({
        ...item,
        Evidence: {
          ...item.Evidence,
          EvidenceId: item.Evidence?.Id,
        },
      });

      setShowAddEventReview(true);
      return;
    }

    setEventReview({
      ...item,
    });

    setShowAddEventReview(true);
  };

  const showAddNoteFromEvidence = (item) => {
    const note = eventReviewData?.Data?.filter(
      (x) => x.Evidence?.Id === item.Id,
    );

    setEventReview({
      ...getClearEventReviewModel(id),
      Id: note?.length > 0 ? note[0].Id : 0,
      Title: note?.length > 0 ? note[0].Title : undefined,
      Observation: note?.length > 0 ? note[0].Observation : undefined,
      EvidenceId: item.Id,
      Evidence: { ...item },
    });

    setShowAddEventReview(true);
  };

  const generateEvidenceActionButtons = (item) => {
    const buttons = [];
    buttons.push({
      name: localize.view,
      icon: <Visibility style={{ width: "16px", height: "16px" }} />,
      action: async () => {
        setSelectedEvidence({ ...item });
        setShowModalGallery(true);
      },
    });

    if (item?.GpsLongitude && item?.GpsLatitude) {
      buttons.push({
        name: localize.gps,
        icon: <LocationOn style={{ width: "16px", height: "16px" }} />,
        action: () => {
          const win = window.open(
            getGoogleMapsLink(item.GpsLatitude, item.GpsLongitude),
            "_blank",
          );
          if (win) win.focus();
        },
      });
    }

    buttons.push({
      name: localize.download,
      icon: <Download style={{ width: "16px", height: "16px" }} />,
      action: () => {
        downloadEvidence(item);
      },
    });

    if (!eventAlreadyFinished()) {
      buttons.push({
        name: localize.add_note,
        icon: <NoteAdd style={{ width: "16px", height: "16px" }} />,
        action: () => {
          showAddNoteFromEvidence(item);
        },
      });
    }

    return buttons;
  };

  const hasEvidences = () => {
    if (!evidenceData || !evidenceData.Data || evidenceData.Data?.length === 0)
      return false;

    return (
      evidenceData.Data.filter(
        (x) =>
          x.Available === 1 && x.EvidenceType !== 5 && x.EvidenceType !== 6,
      ).length > 0
    );
  };

  useEffect(() => {
    if (searchSupplyList && searchSupplyList.length > 0) {
      setQuantityForSupply(1);
      setDetailSupplyUsageObservation("");
      setShowAddSupplyModal(true);
    }
  }, [searchSupplyList]);

  useEffect(() => {
    detailSupplyUsageObservation &&
      setDetailSupplyUsageObservationCount(detailSupplyUsageObservation.length);
  }, [detailSupplyUsageObservation]);

  const handleChangeSupplyUsageDetailObservation = (e) => {
    setDetailSupplyUsageObservation(e.target.value);
  };

  const disableSaveChangesForAdditionalCost = () =>
    additionalCostModel.AdditionalCostTypeId <= 0 ||
    additionalCostModel.Value === 0 ||
    (assignAdditionalCostStatus &&
      additionalCostModel.Status === AdditionalStatusCodeEnum.Rejected &&
      (!additionalCostModel.Observation ||
        additionalCostModel.Observation.length === 0));

  const disableChangesForEvent = () =>
    eventModel?.EventTypeId <= 0 ||
    eventModel?.StateId <= 0 ||
    eventModel?.CityId <= 0 ||
    !eventModel?.Address ||
    eventModel?.Address.replaceAll(" ", "").length <= 0 ||
    !eventModel?.ReporterPhoneNumber ||
    eventModel?.ReporterPhoneNumber.replaceAll(" ", "").length <= 0 ||
    !eventModel?.ReporterName ||
    eventModel?.ReporterName.replaceAll(" ", "").length <= 0;

  const disableChangesForBilling = () =>
    (eventBillingModel?.Billed && eventBillingModel?.Code?.length <= 0) ||
    (!eventBillingModel?.Billed && eventBillingModel?.Observation?.length <= 0);

  const disableSaveChangesForEvidence = () =>
    (!selectedFilesForEvidences ||
      selectedFilesForEvidences.length === 0 ||
      !selectedFilesForEvidences.some((item) => item.Status === 0)) &&
    ((updateEvidenceFile && !evidenceModelForEdition?.File) ||
      !evidenceModelForEdition?.Name ||
      evidenceModelForEdition?.EvidenceType === 0 ||
      (evidenceModelForEdition?.Id === 0 && !updateEvidenceFile));

  const disableSaveChangesForPaymentData = () =>
    (eventPaymentData?.Payed &&
      (!eventPaymentData?.PaymentMethodId ||
        eventPaymentData?.PaymentMethodId <= 0)) ||
    (!eventPaymentData?.Payed &&
      eventPaymentData?.NoPaymentObservation?.length <= 0);

  const disableSaveChangesForFinishReview = () =>
    !finishEventReview?.OperationalStatusSelected;

  const disableSaveChangesForPaymentToTechnician = () =>
    paymentToTechnician?.EventId === 0 ||
    paymentToTechnician?.PersonalId === 0 ||
    paymentToTechnician?.PaymentTypeId === 0 ||
    paymentToTechnician?.Value === 0 ||
    (paymentToTechnician?.PaymentTypeData?.NeedObservation &&
      !paymentToTechnician?.Observation?.trim()) ||
    (paymentToTechnician?.Status === GeneralStatusEnum.Rejected &&
      !paymentToTechnician?.StatusObservation?.trim());

  const disableSaveChangesForEventAssignment = () =>
    !eventModel?.PersonalId || eventModel?.PersonalId <= 0;

  const disableSaveChangesForEventReview = () =>
    !eventReview?.Title || eventReview?.Title.replaceAll(" ", "").length <= 0;

  const disableSaveChangesForStatusChange = () =>
    !newStatus?.FinalStatus || newStatus?.FinalStatus?.Id <= 0;

  const handleEventOptionsClose = (event) => {
    if (
      anchorOptionsRef.current &&
      anchorOptionsRef.current.contains(event.target)
    ) {
      return;
    }

    setOpenEventOptions(false);
  };

  const handleSelectedOptionClick = () => {
    if (selectedOptionIndex >= 0) {
      getEventOptions[selectedOptionIndex].onClick();
    }
  };

  const handleEventOptionsToggle = () => {
    setOpenEventOptions(!openEventOptions);
  };

  const handleEventOptionsClick = (_event, index) => {
    setSelectedOptionIndex(index);
    setOpenEventOptions(false);
  };

  const generateReportClick = () => {
    setShowGenerateInformModal(true);
  };

  const generateSummaryClick = () => {
    setShowEventSummary(true);
  };

  const registerBillClick = () => {
    setShowEventBilling(true);
  };

  const registerPaymentClick = () => {
    setShowEventPayment(true);
  };

  const createRelatedEventClick = () => {
    setEventModel({
      ...getClearEventModel(),
      ProceedingInfo: eventDetailData?.ProceedingInfo,
      ProceedingId: eventDetailData?.ProceedingInfo?.Id,
      Code: eventDetailData?.Code,
      State: eventDetailData?.State,
      StateId: eventDetailData?.State?.Id,
      City: eventDetailData?.City,
      CityId: eventDetailData?.City?.Id,
      ReporterPhoneNumber: eventDetailData?.ReporterPhoneNumber,
      ReporterEmail: eventDetailData?.ReporterEmail,
      Client: eventDetailData?.Client,
      ClientId: eventDetailData?.Client?.Id,
      Address: eventDetailData?.Address,
      AddressComplement: eventDetailData?.AddressComplement,
      ReporterName: eventDetailData?.ReporterName,
      ParentEventCode: eventDetailData?.Code,
      ParentEventId: eventDetailData?.Id,
    });
    setShowCreateVisit(true);
  };

  const paymentToTechnicianClick = () => {
    if (eventDetailData?.PersonalAssigned?.id > 0) {
      setPaymentToTechnician({
        ...getClearPaymenttoTechnicianModel(),
        EventId: eventDetailData?.Id,
        PersonalId: eventDetailData?.PersonalAssigned?.id,
        PersonalData: eventDetailData?.PersonalAssigned,
      });
      setShowPaymentToTechnicianModal(true);
    } else {
      setErrorMessage(localize.error_no_personal_assigned);
      setErrorMessageTitle(localize.personal_not_assigned);
      setShowErrorModal(true);
    }
  };

  const finishOrderClick = () => {
    setFinishEventReview(getClearEventFinishReviewModel(eventDetailData));
    setShowFinishReview(true);
  };

  const requestSettlementClick = () => {
    setOpenEventOptions(false);
    setShowSettlementRequestConfirm(true);
  };

  const registerSignatureClick = () => {
    setOpenEventOptions(false);
    setShowRegisterSignatureModal(true);
  };

  const confirmRequestSettlement = async () => {
    setSettlementRequesting(true);
    try {
      const body = {
        eventIds: `${eventDetailData?.Id}`,
        createdBy: getUserName(),
        Observation: null,
        Mode: "OVERWRITE",
      };
      const resp = await axios.post(`${SETTLEMENT_ENDPOINT}`, body, config);
      setShowSettlementRequestConfirm(false);
      if (resp?.data?.responseCode === 1) {
        setErrorMessage(
          resp?.data?.responseMessage ?? localize.settlement_unexpected_error,
        );
        setErrorMessageTitle(localize.settlement_request_button);
        setShowErrorModal(true);
      } else {
        setShowSettlementRequestSuccess(true);
      }
    } catch (error) {
      setShowSettlementRequestConfirm(false);
      setErrorMessage(
        error?.response?.data?.responseMessage ??
          error?.response?.data?.Data ??
          error?.response?.data ??
          error?.message ??
          localize.error_unexpected,
      );
      setErrorMessageTitle(localize.settlement_request_button);
      setShowErrorModal(true);
    } finally {
      setSettlementRequesting(false);
    }
  };

  const getEventOptions = [
    {
      title: localize.generate_summary,
      onClick: () => {
        generateSummaryClick();
      },
      disabled: false,
    },
    {
      title: localize.generate_inform,
      onClick: () => {
        generateReportClick();
      },
      disabled: false,
    },
    {
      title: localize.create_related_visit,
      onClick: () => {
        createRelatedEventClick();
      },
      disabled: false,
    },
    {
      title: localize.register_bill,
      onClick: () => {
        registerBillClick();
      },
      disabled: eventDetailData?.Bill,
    },
    {
      title: localize.register_payment,
      onClick: () => {
        registerPaymentClick();
      },
      disabled: eventDetailData?.PaymentDate,
    },
    {
      title: `${localize.register} ${localize.register_payment_to_technician}`,
      onClick: () => {
        paymentToTechnicianClick();
      },
      disabled: eventAlreadyFinished(),
    },
    {
      title: localize.settlement_request_button,
      onClick: () => {
        requestSettlementClick();
      },
      disabled: !(
        eventDetailData?.OperationalStatus === 3 ||
        eventDetailData?.OperationalStatus === 4
      ),
    },
    {
      title: localize.register_signatures,
      onClick: () => {
        registerSignatureClick();
      },
      disabled: !(
        eventDetailData?.EventType?.RequestSignature &&
        (eventDetailData?.OperationalStatus === 3 ||
          eventDetailData?.OperationalStatus === 4) &&
        canEditEventInformation()
      ),
    },
    {
      title: localize.finish_review,
      onClick: () => {
        finishOrderClick();
      },
      disabled: !finishButtonMustBeAvailable() || eventAlreadyFinished(),
      color: "crimson",
    },
  ];

  const getEvidenceTabPages = () => [
    {
      Id: 0,
      Name: localize.evidences,
    },
    {
      Id: 1,
      Name: localize.sections,
    },
  ];

  const getTabPages = () => {
    const options = [];

    options.push({
      Id: 0,
      Name: localize.general_information,
    });

    if (
      eventDetailData?.AdditionalFields &&
      eventDetailData?.AdditionalFields.length > 2
    ) {
      options.push({
        Id: 1,
        Name: localize.additional_data,
      });
    }

    if (eventDetailData?.Client) {
      options.push({
        Id: 2,
        Name: localize.client_information,
      });
    }

    if (eventResolutionsData?.length > 0) {
      options.push({
        Id: 3,
        Name: localize.resolutions,
      });
    }

    options.push({
      Id: 4,
      Name: localize.status_historical,
    });

    options.push({
      Id: 5,
      Name: localize.supplies_report,
    });

    if (generalRequests?.length > 0) {
      options.push({
        Id: 6,
        Name: localize.general_requests,
      });
    }

    options.push({
      Id: 7,
      Name: localize.newnesses,
    });

    options.push({
      Id: 8,
      Name: localize.evidences,
    });

    options.push({
      Id: 9,
      Name: localize.additional_costs,
    });

    if (
      eventDetailData?.CurrentStatus?.IsFinal &&
      eventDetailData?.EventType?.ReviewForm
    ) {
      options.push({
        Id: 10,
        Name: localize.visit_report,
      });
    }

    if (eventDetailData?.Bill) {
      options.push({
        Id: 11,
        Name: localize.billing,
      });
    }

    if (eventDetailData?.PaymentDate) {
      options.push({
        Id: 12,
        Name: `${localize.payment_of} ${localize.event}`,
      });
    }

    if (eventSettlements?.length > 0) {
      options.push({
        Id: 15,
        Name: localize.settlement_detail_title,
      });
    }

    if (paymentsToTechnician && paymentsToTechnician.length > 0) {
      options.push({
        Id: 13,
        Name: localize.payment_to_technician,
      });
    }

    options.push({
      Id: 14,
      Name: localize.technical_concept,
    });

    return options.filter((option) => !isEventDetailTabRestricted(option.Id));
  };

  const changeTab = (value) => {
    if (value >= 0) {
      setSelectedTab(value.toString());
      setSelectedTabId(parseInt(value));
    }
  };

  const changeEvidenceTab = (value) => {
    if (value >= 0) {
      setSelectedEvidenceTab(value.toString());
      setSelectedEvidenceTabId(parseInt(value));
    }
  };

  const uploadMultipleEvidences = async () => {
    setIsUploadingMultipleEvidences(true);
    setIsExecutingMultipleEvidencesUpload(true);

    try {
      const copyToUpload = [...selectedFilesForEvidences];

      for (let index = 0; index < copyToUpload.length; index++) {
        try {
          if (selectedFilesForEvidences[index].Status === 0) {
            selectedFilesForEvidences[index].Status =
              EvidenceUploadStatusEnum.Uploading;
            setSelectedFilesForEvidences([...selectedFilesForEvidences]);

            const evidenceModelForEdition = {
              ...copyToUpload[index],
              File: null,
            };

            const fileUploadResult = await fileUpload(
              undefined,
              copyToUpload[index].File,
              evidenceModelForEdition,
            );

            if (fileUploadResult && fileUploadResult.Ok) {
              selectedFilesForEvidences[index].Status =
                EvidenceUploadStatusEnum.Succeeded;
            } else {
              selectedFilesForEvidences[index].Status =
                EvidenceUploadStatusEnum.Failed;
            }
          }
        } catch (innerException) {
          selectedFilesForEvidences[index].Status =
            EvidenceUploadStatusEnum.Failed;
          selectedFilesForEvidences[index].Error = innerException.message;
        } finally {
          setSelectedFilesForEvidences([...selectedFilesForEvidences]);
        }
      }
    } catch (Exception) {
      console.error(
        "An unexpected error has occurred uploading evidences: ",
        Exception,
      );
    } finally {
      setIsExecutingMultipleEvidencesUpload(false);
    }
  };

  const validateSupplyUsageStatusChangeResult = async (operationResult) => {
    if (operationResult?.result) {
      setShowSupplyUsageStatusChangeModal(false);
      window.location.href = `/events/detail/${id}?tab_id=5`;
      return;
    } else if (operationResult?.data) {
      setErrorMessage(operationResult.data);
      setShowErrorModal(true);
    }
    setShowSupplyUsageStatusChangeModal(false);
  };

  const getTotalAdditionalCosts = (additionalCosts) => {
    if (!additionalCosts) {
      return getValueInCurrency(getCurrencyFromSetup(), 0, true);
    }
    const values = additionalCosts
      .filter((x) => x.Status === AdditionalStatusCodeEnum.Approved)
      .map((x) => x.Value);
    const sum = values.reduce((accumulator, currentValue) => {
      return accumulator + currentValue;
    }, 0);
    return getValueInCurrency(getCurrencyFromSetup(), sum, true);
  };

  const getGeneralRequestByEvent = async () => {
    const requestConfig = {
      ...config,
      headers: {
        ...config.headers,
        Filter: JSON.stringify([
          {
            Name: "Event",
            FriendlyName: localize.event,
            FilterValue: {
              Value: id,
            },
            Value: id,
          },
        ]),
        Pagination: -1,
      },
    };
    const data = await axios.get(`${GENERAL_REQUESTS_ENDPOINT}`, requestConfig);

    if (data?.data?.Data?.length > 0) {
      setGeneralRequests([...data.data.Data]);
      return;
    }

    setGeneralRequests([]);
  };

  const getEvidencesSections = async () => {
    const data = await axios.get(
      `${EVENTS_API}/${id}/evidence-section`,
      config,
    );

    if (data?.data?.length > 0) {
      setEvidencesSections([...data.data]);
      return;
    }

    setEvidencesSections([]);
  };

  const renderEventTabPanels = () => (
    <>
        <TabPanel value="0" index={0}>
          <Box className="flex flex-col w-full gap-4">
            <EventDataDetails
              data={{
                address: eventDetailData?.Address
                  ? `${eventDetailData?.Address} ${
                      eventDetailData?.AddressComplement ?? ""
                    }`
                  : eventDetailData?.AddressComplement,
                city: eventDetailData?.City?.Name ?? localize.no_data,
                department: eventDetailData?.State?.Name ?? localize.no_data,
                phoneNumber:
                  eventDetailData?.ReporterPhoneNumber ?? localize.no_data,
                email: eventDetailData?.ReporterEmail ?? localize.no_data,
                reportedBy: eventDetailData?.ReporterName ?? localize.no_data,
                assignedTo: assignedPersonalOrAssignmentButton(),
                assignedBy: eventDetailData?.AssignedBy ?? localize.no_data,
                expectedAttentionDate: getExpectedSolutionDate(eventDetailData),
                creationDate: new Date(
                  eventDetailData?.CreationDate,
                ).toLocaleString(undefined, {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                }),
                modificationDate: new Date(
                  eventDetailData?.ModificationDate,
                ).toLocaleString(undefined, {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                }),
                modifiedBy: eventDetailData?.CreatedBy,
                vehicle: eventDetailData?.VehicleAssigned?.Identification
                  ? eventDetailData?.VehicleAssigned?.VehicleType
                    ? `${eventDetailData?.VehicleAssigned?.Identification} (${
                        eventDetailData?.VehicleAssigned?.VehicleType?.Name ??
                        eventDetailData?.VehicleAssigned?.VehicleType
                      })`
                    : eventDetailData?.VehicleAssigned?.Identification
                  : localize.no_data,
                driver: eventDetailData?.Driver ?? localize.no_data,
              }}
            />

            {eventDetailData?.Observation && (
              <Alert severity="info">
                <span className="text-xs">
                  <b>{localize.activity_description}: </b>
                  {eventDetailData?.Observation}
                </span>
              </Alert>
            )}

            <Box
              sx={{
                display: "flex",
                gap: 2,
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Card>
                  <EventMoneyData
                    data={{
                      serviceValue: eventDetailData?.executionFinalValue ?? 0,
                      sparePartsValue:
                        eventDetailData?.sparePartsFinalValue ?? 0,
                      additionalCosts: getAdditionalCostValue(),
                      totalValue:
                        getEventTotalValue(eventDetailData, true) ?? 0,
                      sparePartsRealValue:
                        eventDetailData?.sparePartsRealValue ?? 0,
                      paymentToTechnicians:
                        eventDetailData?.paymentToTechnicians &&
                        eventDetailData?.paymentToTechnicians > 0
                          ? eventDetailData?.paymentToTechnicians
                          : 0,
                      realIncome: eventDetailData?.realIncome ?? 0,
                    }}
                    dataEditionFunction={
                      canEditEventInformation() &&
                      eventDetailData.OperationalStatus > 0
                        ? assignEventValues
                        : undefined
                    }
                  />
                </Card>
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <TimeDistributionCard data={statisticsData?.Data} />
              </Box>
            </Box>
          </Box>
        </TabPanel>

        {eventDetailData?.AdditionalFields &&
          eventDetailData?.AdditionalFields.length > 2 && (
            <TabPanel value="1" index={1}>
              <Card
                sx={{
                  borderRadius: 2,
                  p: 2,
                  background: "#fdfdff",
                  width: "100%",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(280px, 1fr))",
                      gap: 3,
                    }}
                  >
                    {(() => {
                      const items = generateAdditionalDataInfo(
                        eventDetailData?.AdditionalFields,
                      );
                      const columns = [];
                      for (let i = 0; i < items.length; i += 3) {
                        columns.push(items.slice(i, i + 3));
                      }
                      return columns.map((col, colIdx) => (
                        <Box key={colIdx}>
                          {col.map((item, idx) => (
                            <Box
                              key={idx}
                              display="flex"
                              alignItems="flex-start"
                              gap={1.5}
                              mb={2}
                            >
                              <Box>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {item.fieldName}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  sx={{ fontWeight: 500 }}
                                >
                                  {item.fieldValue ?? localize.no_data}
                                </Typography>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      ));
                    })()}
                  </Box>
                </CardContent>
              </Card>
            </TabPanel>
          )}

        {eventDetailData?.Client && (
          <TabPanel value="2" index={2}>
            <EventClientDatadetails
              data={{
                identificationType:
                  eventDetailData?.Client?.IdentificationType ??
                  localize.no_data,
                identification:
                  eventDetailData?.Client?.Identification ?? localize.no_data,
                name: eventDetailData?.Client?.Name ?? localize.no_data,
                phoneNumber:
                  eventDetailData?.Client?.PhoneNumber ?? localize.no_data,
                email: eventDetailData?.Client?.Email ?? localize.no_data,
                contactName:
                  eventDetailData?.Client?.ContactName ?? localize.no_data,
                address: eventDetailData?.Client?.Address
                  ? `${eventDetailData?.Client?.Address} ${
                      eventDetailData?.Client?.AddressComplement ?? ""
                    }`
                  : eventDetailData?.Client?.AddressComplement ??
                    localize.no_data,
                city: eventDetailData?.Client?.City?.Name ?? localize.no_data,
                department:
                  eventDetailData?.Client?.State?.Name ?? localize.no_data,
              }}
            />
          </TabPanel>
        )}

        {eventResolutionsData?.length > 0 && (
          <TabPanel value="3" index={3}>
            <div className="w-full">
              <TableComponent
                noPadding
                columnTitles={[
                  localize.code,
                  localize.resolution,
                  localize.description,
                ]}
                results={eventResolutionsData.map((resolution) => ({
                  key: resolution?.Id,
                  data: [
                    <ValueOrNoDataLabel data={resolution?.Resolution?.Code} />,
                    <ValueOrNoDataLabel data={resolution?.Resolution?.Name} />,
                    <ValueOrNoDataLabel
                      data={resolution?.Resolution?.Description}
                    />,
                  ],
                }))}
              />
            </div>
          </TabPanel>
        )}

        <TabPanel value="4" index={4}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "stretch", sm: "center" },
              gap: 2,
              width: "100%",
            }}
          >
            <Alert sx={{ width: "100%" }} severity="info">
              <label className="text-xs">
                {localize.status_changes_description}
              </label>
            </Alert>
            {canEditEventInformation() &&
              eventDetailData.OperationalStatus > 0 && (
                <Button
                  size="medium"
                  variant="contained"
                  color="success"
                  className="app_general_button_data app_success_button"
                  sx={{
                    px: "16px",
                    py: "8px",
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                  }}
                  onClick={() => {
                    setNewStatus({});
                    setShowAddStatusChangeModal(true);
                  }}
                >
                  {isMobile ? localize.add : localize.add_status_change}
                  <div className="mr-1" />
                  <Add style={{ width: "16px", height: "16px" }} />
                </Button>
              )}
          </Box>

          <div className="my-2">
            <Divider />
          </div>
          <div
            className="w-full"
            style={{
              display: "flex",
              alignItems: "start",
            }}
          >
            <StateChangeTimeline
              eventModel={eventDetailData}
              timelineData={statusChangeData?.Data || []}
              firstStatusChange={
                statusChangeData?.Data?.length > 0
                  ? statusChangeData.Data[0]
                  : undefined
              }
              dynamicFormModel={dynamicFormForReview}
              setDynamicFormModel={setDynamicFormForReview}
              canEditValues={canEditEventInformation()}
            />
          </div>
        </TabPanel>

        <TabPanel value="5" index={5}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "stretch", sm: "center" },
              gap: 2,
              width: "100%",
              mb: 1,
            }}
          >
            <Alert sx={{ width: "100%" }} severity="info">
              <label className="text-xs">
                {localize.supplies_used_on_event}
              </label>
            </Alert>

            {canEditEventInformation() &&
              eventDetailData.OperationalStatus > 0 && (
                <Button
                  size="medium"
                  variant="contained"
                  color="success"
                  className="app_general_button_data app_success_button"
                  sx={{ px: "16px", py: "8px", whiteSpace: "nowrap" }}
                  onClick={() => {
                    setPageIndexSupply(-1);
                    setUsedWarehouse(
                      eventDetailData?.PersonalAssigned?.Warehouse,
                    );
                    setShowSupplySearchModal(true);
                  }}
                >
                  {isMobile ? localize.add : localize.add_supply}
                  <div className="mr-1" />
                  <Add style={{ width: "16px", height: "16px" }} />
                </Button>
              )}
          </Box>
          <div className="my-2">
            <Divider />
          </div>
          <TableComponent
            noPadding
            firstColumnTitle={
              canEditEventInformation() ? localize.actions : null
            }
            columnTitles={[
              localize.quantity,
              localize.name,
              localize.measurement_unit,
              localize.status,
              localize.warehouse,
              localize.observations,
              localize.reported_by,
            ]}
            results={
              supplyData.Data?.length !== 0
                ? supplyData?.Data?.map((item) => ({
                    key: item.Id,
                    data: generateSupplyTableData(item),
                  }))
                : [generateNoDataValues(canEditEventInformation() ? 8 : 7)]
            }
          />
        </TabPanel>

        {generalRequests?.length > 0 && (
          <TabPanel value="6" index={6}>
            <div className="flex flex-col mr-5 mb-2">
              <Alert className="w-full" severity="info">
                <label className="text-xs">
                  {localize.general_requests_description_on_event_detail}
                </label>
              </Alert>
              <div className="my-2">
                <Divider />
              </div>
              <TableComponent
                firstColumnTitle={" "}
                noPadding
                columnTitles={[
                  localize.type,
                  localize.status,
                  localize.client,
                  localize.assigned_to,
                  localize.expected_attention_date,
                  localize.modified_by,
                  localize.modification_date,
                ]}
                results={
                  generalRequests?.length > 0
                    ? generalRequests.map((item) => ({
                        key: item.Id,
                        data: [
                          <WarningErrorStatus
                            currentValue={getCurrentDays(item)}
                            limitForWarning={getDaysToWarning(item)}
                            limitForError={getDaysToError(item)}
                            isSucceeded={item?.Status === 2}
                            isFailed={item?.Status === 3}
                          />,
                          <BackForeColor
                            backColor={item?.Type?.BackgroundColor}
                            foreColor={item?.Type?.ForegroundColor}
                            text={item?.Type?.Name}
                          />,
                          <RequestStatus status={item.Status} />,
                          <ValueOrNoDataLabel data={item?.Client?.Name} />,
                          <p>{`${item?.PersonalAssigned?.SurName} ${
                            item?.PersonalAssigned?.LastName ?? ""
                          }`}</p>,
                          GetDateInDDMMYYYYFormat(
                            new Date(item?.ExpectedSolutionDate),
                          ),
                          <ValueOrNoDataLabel data={item?.CreatedBy} />,
                          new Date(item?.ModificationDate).toLocaleString(
                            undefined,
                            {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                            },
                          ),
                        ],
                      }))
                    : [generateNoDataValues(6)]
                }
              />
            </div>
          </TabPanel>
        )}

        <TabPanel value="7" index={7}>
          <div className="flex flex-col mr-5 mb-2">
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
                alignItems: { xs: "stretch", sm: "center" },
                gap: 2,
              }}
            >
              <Alert className="w-full" severity="info">
                <label className="text-xs">
                  {localize.newnesses_description}
                </label>
              </Alert>
              {canEditEventInformation() && (
                <Button
                  size="medium"
                  variant="contained"
                  color="success"
                  sx={{ flexShrink: 0 }}
                  onClick={() => {
                    setNewnessModel({
                      AdditionalNewness: null,
                      AdditionalNewnessId: 0,
                      Observation: "",
                    });
                    setShowAddNewnessModal(true);
                  }}
                >
                  {localize.add}
                  <div className="mr-2" />
                  <Add style={{ width: "16px", height: "16px" }} />
                </Button>
              )}
            </Box>

            <div className="my-2">
              <Divider />
            </div>

            <TableComponent
              noPadding
              columnTitles={[
                localize.newness,
                localize.occurr_time,
                localize.reported_by,
                localize.observations,
              ]}
              results={
                newnessData.Data?.length > 0
                  ? newnessData?.Data?.map((item) => ({
                      key: item.Id,
                      data: [
                        <ValueOrNoDataLabel
                          data={getNewnessDescription(item)}
                        />,
                        new Date(item.OccurrTime).toLocaleString(undefined, {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          timeZone: "UTC",
                        }),
                        <ValueOrNoDataLabel data={item?.CreatedBy} />,
                        <ValueOrNoDataLabel data={item?.Observation} />,
                      ],
                    }))
                  : [generateNoDataValues(4)]
              }
            />
          </div>
        </TabPanel>

        <TabPanel value="8" index={8}>
          <Box sx={{ mb: 2 }}>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={12} sm>
                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  <ScrollablePageTab
                    selectedPage={selectedEvidenceTabId}
                    setSelectedPage={changeEvidenceTab}
                    noMarginTop
                    dynamicFormPages={getEvidenceTabPages()}
                    maxWidthValue={"100%"}
                    reportTabId
                    customJustifyContent={"flex-start"}
                  />
                </Box>
              </Grid>

              {hasEvidences() > 0 && (
                <>
                  <Grid item xs={6} sm="auto">
                    <Button
                      fullWidth
                      disabled={isDownloadingEvidences}
                      size="small"
                      variant="contained"
                      sx={{ backgroundColor: "#10366E !important" }}
                      onClick={() => {
                        downloadEvidences(
                          eventDetailData.Id,
                          evidenceData?.Data,
                          eventDetailData.Code,
                        );
                      }}
                    >
                      {localize.download}
                      <div className="mr-2" />
                      <Download style={{ width: "16px", height: "16px" }} />
                    </Button>
                  </Grid>
                  <Grid item xs={6} sm="auto">
                    <Button
                      fullWidth
                      size="small"
                      variant="contained"
                      sx={{ backgroundColor: "#10366E !important" }}
                      onClick={() => {
                        setShowModalGallery(true);
                      }}
                    >
                      {localize.view_gallery}
                      <div className="mr-2" />
                      <Collections style={{ width: "16px", height: "16px" }} />
                    </Button>
                  </Grid>
                </>
              )}

              {canEditEventInformation() && (
                <>
                  <Grid item xs={6} sm="auto">
                    <Button
                      fullWidth
                      size="small"
                      variant="contained"
                      color="success"
                      onClick={() => {
                        setSectionModel(
                          getClearSectionModel(eventDetailData?.Id),
                        );
                        setShowSectionForm(true);
                      }}
                    >
                      {`${localize.add} ${localize.section}`}
                      <div className="mr-2" />
                      <Add style={{ width: "16px", height: "16px" }} />
                    </Button>
                  </Grid>
                  <Grid item xs={6} sm="auto">
                    <Button
                      fullWidth
                      size="small"
                      variant="contained"
                      color="success"
                      onClick={() => {
                        setUpdateEvidenceFile(true);
                        setEvidenceModelForEdition(
                          getClearEvidenceModel(eventDetailData?.Id),
                        );
                        setIsUploadingMultipleEvidences(false);
                        setSelectedFilesForEvidences([]);
                        setShowEvidenceModal(true);
                      }}
                    >
                      {localize.add_evidence}
                      <div className="mr-2" />
                      <Add style={{ width: "16px", height: "16px" }} />
                    </Button>
                  </Grid>
                </>
              )}

              <Grid item xs={12} sx={{ display: { xs: "block", sm: "none" } }}>
                <ScrollablePageTab
                  selectedPage={selectedEvidenceTabId}
                  setSelectedPage={changeEvidenceTab}
                  noMarginTop
                  dynamicFormPages={getEvidenceTabPages()}
                  maxWidthValue={"100%"}
                  reportTabId
                  customJustifyContent={"flex-start"}
                />
              </Grid>
            </Grid>
          </Box>
          <div className="my-2">
            <Divider />
          </div>

          {selectedEvidenceTabId === 0 && (
            <TableComponent
              noPadding
              firstColumnTitle={localize.actions}
              columnTitles={[
                localize.name,
                localize.evidence_type,
                localize.visible_on_report,
                localize.section,
                localize.creation_date,
                localize.reported_by,
                localize.origin,
              ]}
              results={
                hasEvidences()
                  ? evidenceData?.Data?.filter(
                      (x) =>
                        x.Available === 1 &&
                        x.EvidenceType !== 5 &&
                        x.EvidenceType !== 6,
                    )?.map((item) => ({
                      key: item.Id,
                      data: [
                        <ActionButtons
                          hideEditButton={!canEditEventInformation()}
                          onClickForEditButton={() => {
                            setSelectedFilesForEvidences([]);
                            setEvidenceModelForEdition({
                              ...item,
                              eventId: id,
                            });
                            setIsUploadingMultipleEvidences(false);
                            setShowEvidenceModal(true);
                          }}
                          hideDeleteButton={!canEditEventInformation()}
                          onclickForDeleteButton={() => {
                            setEvidenceModelForEdition(item);
                            setShowDeleteModal(true);
                            toggleVisibleModalConfirm();
                          }}
                          buttons={generateEvidenceActionButtons(item)}
                        />,
                        <ValueOrNoDataLabel data={item?.Name} />,
                        <ValueOrNoDataLabel
                          data={getEvidenceType(item.EvidenceType)}
                        />,
                        <TrueFalseImage
                          value={!isEvidenceInvisible(item.Id)}
                          onClick={() => {
                            ToggleEvidenceVisibility(item.Id);
                          }}
                          toolTip={`${
                            isEvidenceInvisible(item.Id)
                              ? localize.invisible_on_report
                              : localize.visible_on_report
                          }. ${localize.click_to_change}`}
                        />,
                        <ValueOrNoDataLabel
                          data={
                            item?.Section?.RegisterStatus === 1
                              ? item?.Section?.Name
                              : undefined
                          }
                        />,
                        new Date(item.ModificationDate).toLocaleString(
                          undefined,
                          {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                          },
                        ),
                        <ValueOrNoDataLabel
                          data={
                            item?.FromWeb
                              ? `${localize.modified_by}: ${item?.ModifiedBy}`
                              : item?.CreatedBy
                          }
                        />,
                        <ValueOrNoDataLabel
                          data={
                            item?.FromWeb
                              ? localize.from_web
                              : localize.from_app
                          }
                        />,
                      ],
                    }))
                  : [generateNoDataValues(8)]
              }
            />
          )}

          {selectedEvidenceTabId === 1 && (
            <TableComponent
              noPadding
              firstColumnTitle={localize.actions}
              columnTitles={[
                localize.name,
                localize.description,
                localize.modification_date,
                localize.modified_by,
              ]}
              results={
                evidencesSections?.length > 0
                  ? evidencesSections.map((item) => ({
                      key: item.Id,
                      data: [
                        <ActionButtons
                          onClickForEditButton={() => {
                            setSectionModel({ ...item, EventId: id });
                            setShowSectionForm(true);
                          }}
                          onclickForDeleteButton={() => {
                            setSectionModel({ ...item, EventId: id });
                            setShowDeleteSectionModal(true);
                            toggleVisibleModalConfirm();
                          }}
                        />,
                        <ValueOrNoDataLabel data={item?.Name} />,
                        <ValueOrNoDataLabel data={item?.Description} />,
                        new Date(item.ModificationDate).toLocaleString(
                          undefined,
                          {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                          },
                        ),
                        <ValueOrNoDataLabel data={item?.CreatedBy} />,
                      ],
                    }))
                  : [generateNoDataValues(5)]
              }
            />
          )}
        </TabPanel>

        <TabPanel value="9" index={9}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "stretch", sm: "center" },
              mb: 1,
              gap: 2,
            }}
          >
            <Alert severity="info" sx={{ width: "100%" }}>
              <label className="text-xs">
                {localize.add_additional_costs_description}
              </label>
            </Alert>
            {canEditEventInformation() && (
              <Button
                size="medium"
                variant="contained"
                color="success"
                sx={{ flexShrink: 0, order: { xs: 0, sm: 1 } }}
                onClick={() => {
                  setAdditionalCostModel(
                    getClearAdditionalCostModel(eventDetailData?.Id),
                  );
                  setAssignAdditionalCostStatus(false);
                  setShowAdditionalCostsModal(true);
                }}
              >
                {isMobile ? localize.add : localize.add_additional_cost}
                <div className="mr-2" />
                <Add style={{ width: "16px", height: "16px" }} />
              </Button>
            )}
            <Typography
              className="field_title_text"
              sx={{ order: { xs: 1, sm: 0 }, flexShrink: 0 }}
            >
              <b>{`${localize.total_approved_additional_costs}: ${getTotalAdditionalCosts(
                additionalCosts?.Data,
              )}`}</b>
            </Typography>
          </Box>
          <div className="my-2">
            <Divider />
          </div>
          <TableComponent
            noPadding
            columnTitles={[
              localize.actions,
              localize.additional_cost_type,
              localize.value,
              localize.status,
              localize.observations,
              localize.creation_date,
              localize.reported_by,
            ]}
            results={
              additionalCosts?.Data && additionalCosts.Data.length > 0
                ? additionalCosts.Data.map((item) => ({
                    key: item.Id,
                    data: [
                      <div className="flex items-center align-center justify-center">
                        <Box>
                          <IconButton
                            disabled={
                              item.Status > 0 || !canEditEventInformation()
                            }
                            onClick={() => {
                              setAdditionalCostModel({
                                ...item,
                                AdditionalCostTypeId:
                                  item.AdditionalCostType?.Id,
                                EventId: eventDetailData?.Id,
                              });
                              setAssignAdditionalCostStatus(true);
                              setShowAdditionalCostsModal(true);
                            }}
                          >
                            <Edit
                              style={{
                                color: "#10366E",
                                width: "16px",
                                height: "16px",
                              }}
                            />
                          </IconButton>
                        </Box>
                      </div>,
                      <ValueOrNoDataLabel
                        data={item.AdditionalCostType?.Name}
                      />,
                      <ValueOrNoDataLabel
                        data={getValueInCurrency(
                          getCurrencyFromSetup(),
                          item.Value,
                        )}
                      />,
                      <BackForeColor
                        backColor={getAdditionalCostStatusBackColor(
                          item.Status,
                        )}
                        foreColor={getAdditionalCostStatusForeColor(
                          item.Status,
                        )}
                        text={getAdditionalCostStatusName(item.Status)}
                      />,
                      <ValueOrNoDataLabel data={item?.Observation} />,
                      new Date(item.CreationDate).toLocaleString(undefined, {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      }),
                      item.CreatedBy,
                    ],
                  }))
                : [generateNoDataValues(7)]
            }
          />
        </TabPanel>

        {eventDetailData?.CurrentStatus?.IsFinal &&
          eventDetailData?.EventType?.ReviewForm && (
            <TabPanel value="10" index={10}>
              <div className="flex-column w-full">
                <DynamicFormReview
                  eventId={id}
                  dynamicFormModel={eventDetailData?.EventType?.ReviewForm}
                  showSaveButton={false}
                  allFieldsDisabled={!canEditEventInformation()}
                />
              </div>
            </TabPanel>
          )}

        {eventDetailData?.Bill && (
          <TabPanel value="11" index={11}>
            {!eventDetailData?.Bill?.Billed ? (
              <Alert severity="error">
                <label className="text-xs">
                  <b>{localize.not_billed}: </b>
                  {eventDetailData?.Bill?.Observation}
                </label>
              </Alert>
            ) : (
              <Card
                sx={{
                  borderRadius: 2,
                  p: 2,
                  background: "#fdfdff",
                  width: "100%",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(280px, 1fr))",
                      gap: 3,
                    }}
                  >
                    {(() => {
                      const columns = [];
                      for (let i = 0; i < billingData.length; i += 3) {
                        columns.push(billingData.slice(i, i + 3));
                      }
                      return columns.map((col, colIdx) => (
                        <Box key={colIdx}>
                          {col.map((item, idx) => (
                            <Box
                              key={idx}
                              display="flex"
                              alignItems="flex-start"
                              gap={1.5}
                              mb={2}
                            >
                              <Box>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {item.fieldName}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  sx={{ fontWeight: 500 }}
                                >
                                  {item.fieldValue ?? localize.no_data}
                                </Typography>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      ));
                    })()}
                  </Box>
                </CardContent>
              </Card>
            )}
          </TabPanel>
        )}

        {eventDetailData?.PaymentDate && (
          <TabPanel value="12" index={12}>
            {!eventDetailData?.Payed ? (
              <Alert severity="error">
                <label className="text-xs">
                  <b>{localize.not_payed}: </b>
                  {eventDetailData?.NoPaymentObservation}
                </label>
              </Alert>
            ) : (
              <Card
                sx={{
                  borderRadius: 2,
                  p: 2,
                  background: "#fdfdff",
                  width: "100%",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(280px, 1fr))",
                      gap: 3,
                    }}
                  >
                    {(() => {
                      const items = createEventPaymentData();
                      const columns = [];
                      for (let i = 0; i < items.length; i += 3) {
                        columns.push(items.slice(i, i + 3));
                      }
                      return columns.map((col, colIdx) => (
                        <Box key={colIdx}>
                          {col.map((item, idx) => (
                            <Box
                              key={idx}
                              display="flex"
                              alignItems="flex-start"
                              gap={1.5}
                              mb={2}
                            >
                              <Box>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {item.fieldName}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  sx={{ fontWeight: 500 }}
                                >
                                  {item.fieldValue ?? localize.no_data}
                                </Typography>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      ));
                    })()}
                  </Box>
                </CardContent>
              </Card>
            )}
          </TabPanel>
        )}

        {paymentsToTechnician && paymentsToTechnician.length > 0 && (
          <TabPanel value="13" index={13}>
            {paymentsToTechnician && paymentsToTechnician.length > 0 && (
              <div
                className="fullWidth"
                style={{ display: "flex", flexDirection: "row-reverse" }}
              >
                <div style={{ marginRight: "18px" }}>
                  <Typography className="field_title_text">
                    <b>{`${localize.total_value} (${
                      localize.approved
                    }): ${getTotalPaymentToTechnician(
                      paymentsToTechnician,
                    )}`}</b>
                  </Typography>
                </div>
              </div>
            )}

            <TableComponent
              noPadding
              firstColumnTitle={localize.actions}
              columnTitles={[
                localize.payment_date,
                localize.payment_type,
                localize.personal,
                localize.value,
                localize.status,
                localize.observations,
                localize.reported_by,
              ]}
              results={
                paymentsToTechnician && paymentsToTechnician.length > 0
                  ? paymentsToTechnician.map((item) => ({
                      key: item.Id,
                      data: [
                        <ActionButtons
                          hideDeleteButton
                          hideEditButton
                          detailsButtonText={localize.answer_to_request}
                          onClickForDetailButton={() => {
                            setPaymentToTechnician({
                              ...item,
                              EventId: id,
                              PersonalId: item?.PersonalData?.id,
                              PaymentTypeId: item?.PaymentTypeData?.Id,
                              PaymentDate: GetDateInYYYYMMDDHHmmss(new Date()),
                            });
                            setShowPaymentToTechnicianModal(true);
                          }}
                          disabled={item.Status > 0}
                        />,
                        GetDateInMMDDYYYYFormat(new Date(item.PaymentDate)),
                        <ValueOrNoDataLabel
                          data={item.PaymentTypeData?.Name}
                        />,
                        <ValueOrNoDataLabel
                          data={`${item.PersonalData?.SurName} ${item.PersonalData?.LastName}`}
                        />,
                        <ValueOrNoDataLabel
                          data={getValueInCurrency(
                            getCurrencyFromSetup(),
                            item.Value,
                          )}
                        />,
                        <BackForeColor
                          text={getGeneralStatusName[item.Status]}
                          backColor={getGeneralStatusBackColor[item.Status]}
                          foreColor={getGeneralStatusForeColor[item.Status]}
                          TooltipText={item.StatusObservation}
                        />,
                        <ValueOrNoDataLabel data={item.Observation} />,
                        item.CreatedBy,
                      ],
                    }))
                  : [generateNoDataValues(4)]
              }
            />
          </TabPanel>
        )}

        <TabPanel value="14" index={14}>
          <div className="flex-column w-full">
            <div className="flex justify-between w-full">
              {!eventAlreadyFinished() && (
                <div>
                  <Button
                    size="medium"
                    variant="contained"
                    color="success"
                    onClick={() => {
                      setEventReview(getClearEventReviewModel(id));
                      setShowAddEventReview(true);
                    }}
                  >
                    <span className="mr-2">{isMobile ? localize.add : `${localize.add} ${localize.note}`}</span>
                    <Add style={{ width: "16px", height: "16px" }} />
                  </Button>
                </div>
              )}
            </div>

            <div className="flex items-center justify-between w-full">
              {eventAlreadyFinished() && (
                <div className="w-full mt-2 flex flex-col gap-2">
                  <Alert
                    severity={
                      eventDetailData?.FinishObservation &&
                      eventDetailData?.OperationalStatus !==
                        OperationalStatusEnum.Canceled
                        ? "info"
                        : "warning"
                    }
                  >
                    <label className="text-xs">
                      {eventDetailData?.FinishObservation &&
                      eventDetailData?.OperationalStatus >
                        OperationalStatusEnum.Canceled ? (
                        <Box className="flex flex-col gap-2">
                          {eventDetailData?.FinishConcept && (
                            <span>
                              <b>{localize.finish_concept}:</b>{" "}
                              {eventDetailData?.FinishConcept?.Name}
                            </span>
                          )}
                          <span>
                            <b>{localize.conclusions}:</b>{" "}
                            {eventDetailData?.FinishObservation}
                          </span>
                        </Box>
                      ) : (
                        <Box className="flex flex-col gap-2">
                          {eventDetailData?.FinishConcept && (
                            <span>
                              <b>{localize.finish_concept}:</b>{" "}
                              {eventDetailData?.FinishConcept?.Name}
                            </span>
                          )}
                          <span>{localize.finished_without_conslusions}</span>
                        </Box>
                      )}
                    </label>
                  </Alert>

                  <Divider />
                </div>
              )}
            </div>

            {(!eventAlreadyFinished() ||
              (eventReviewData?.Data && eventReviewData?.Data.length > 0)) && (
              <Alert severity="info" className="mt-4">
                <label className="text-xs">{localize.notes_description}</label>
              </Alert>
            )}

            {eventReviewData?.Data && eventReviewData?.Data.length > 0 && (
              <EventReviewViewer
                eventId={id}
                eventReviews={eventReviewData?.Data}
                showEditNoteMethod={
                  !eventAlreadyFinished() ? showEditReview : undefined
                }
              />
            )}
          </div>
        </TabPanel>
        {eventSettlements?.length > 0 && (
          <TabPanel value="15" index={15}>
            <EventSettlementDetails details={eventSettlements} />
          </TabPanel>
        )}
    </>
  );

  return (
    <div className="p-5">
      {showSectionForm && (
        <AddOrEditSection
          show={showSectionForm}
          setShow={setShowSectionForm}
          sectionModel={sectionModel}
          onSuccess={() => {
            setSuccessNotificationMessage(localize.section_saved_successfully);
            setShowSuccessNotification(true);
            getEvidencesSections();
            getEvidences();
          }}
        />
      )}

      {showSupplyUsageStatusChangeModal && (
        <SupplyRequestStatusChange
          show={showSupplyUsageStatusChangeModal}
          setShow={setShowSupplyUsageStatusChangeModal}
          supplyUsageModel={supplyUsageEditionModel}
          onResult={(operationResult) => {
            validateSupplyUsageStatusChangeResult(operationResult);
          }}
          eventId={eventDetailData.Id}
        />
      )}

      {showServiceValuesModal && (
        <ModalBackground
          isDrawerMode
          showModal={showServiceValuesModal}
          setShowModal={setShowServiceValuesModal}
          title={`${localize.set_service_values} # ${eventDetailData.Id} (${eventDetailData.Code})`}
          onClickToCancel={() => {
            setEventDetailValues({
              sparePartsFinalValue: eventDetailData.sparePartsFinalValue,
              executionFinalValue: eventDetailData.executionFinalValue,
              sparePartsRealValue: eventDetailData.sparePartsRealValue,
            });
            setShowServiceValuesModal(false);
          }}
          onClickToSubmit={() => {
            setShowServiceValuesModal(false);
            UpdateServiceValues();
          }}
          Component={
            <SetServiceValues
              eventModel={eventDetailValues}
              setEventModel={setEventDetailValues}
            />
          }
        />
      )}

      {showSuccessNotification && (
        <ModalBackground
          showModal={showSuccessNotification}
          setShowModal={setShowSuccessNotification}
          title={localize.process_succeeded}
          onClickToSubmit={() => {
            setShowSuccessNotification(false);
          }}
          hideCancelButton
          okButtonText={localize.ok}
          Component={<Typography>{successNotificationMessage}</Typography>}
        />
      )}

      {showSettlementRequestConfirm && (
        <ModalBackground
          showModal={showSettlementRequestConfirm}
          setShowModal={setShowSettlementRequestConfirm}
          title={localize.settlement_request_button}
          onClickToSubmit={() => {
            confirmRequestSettlement();
          }}
          okButtonText={localize.confirm}
          cancelButtonText={localize.cancel}
          validators={settlementRequesting}
          Component={
            <Typography>{localize.settlement_request_confirm}</Typography>
          }
        />
      )}

      {showSettlementRequestSuccess && (
        <ModalBackground
          showModal={showSettlementRequestSuccess}
          setShowModal={setShowSettlementRequestSuccess}
          title={localize.process_succeeded}
          onClickToSubmit={() => {
            setShowSettlementRequestSuccess(false);
            window.location.href = `/events/detail/${id}?tab_id=15`;
          }}
          hideCancelButton
          okButtonAlwaysAvailable
          okButtonText={localize.ok}
          Component={
            <Typography>{localize.settlement_created_success}</Typography>
          }
        />
      )}

      {showRegisterSignatureModal && (
        <RegisterSignatureWizard
          show={showRegisterSignatureModal}
          setShow={setShowRegisterSignatureModal}
          eventId={id}
          eventCode={getCode()}
          onSaved={async () => {
            await getEvidences();
            showUpdateMessage();
          }}
        />
      )}

      {showAddNewnessModal && (
        <ModalBackground
          isDrawerMode
          title={localize.add_newness}
          showModal={showAddNewnessModal}
          setShowModal={setShowAddNewnessModal}
          onClickToSubmit={createNewness}
          validators={disableSaveNewness()}
          hasRequiredValues={disableSaveNewness()}
          Component={
            <AddNewness
              options={additionalNewnessOptions}
              newnessModel={newnessModel}
              setNewnessModel={setNewnessModel}
            />
          }
        />
      )}

      {showAddNewnessSuccess && (
        <ModalBackground
          showModal={showAddNewnessSuccess}
          setShowModal={setShowAddNewnessSuccess}
          title={localize.process_succeeded}
          hideCancelButton
          okButtonAlwaysAvailable
          okButtonText={localize.ok}
          onClickToSubmit={() => {
            setShowAddNewnessSuccess(false);
            getNewnesses();
          }}
          Component={<Typography>{localize.service_order_updated}</Typography>}
        />
      )}

      {showSupplyItemDeleteConfirmation && (
        <DeleteConfirmationMessage
          entityType={localize.supply}
          entityName={`${
            supplyItemToDelete?.SupplyData?.Code
              ? `${supplyItemToDelete?.SupplyData?.Code} - `
              : ""
          }${supplyItemToDelete?.SupplyData?.Name} (${localize.quantity}: ${
            supplyItemToDelete?.Quantity
          })`}
          additionalMessage={
            supplyItemToDelete.Status === 1 && (
              <Alert className="w-full" severity="warning">
                <label className="text-xs">
                  {localize.note_for_delete_supply_usage}
                </label>
              </Alert>
            )
          }
          onClickForCancel={() => {
            toggleVisibleModalConfirm();
            setSupplyItemToDelete(null);
            setShowSupplyItemDeleteConfirmation(false);
          }}
          onClickForConfirm={() => {
            deleteSupplyItem(supplyItemToDelete);
            setShowSupplyItemDeleteConfirmation(false);
            toggleVisibleModalConfirm();
          }}
        />
      )}

      {showEventPayment && (
        <ModalBackground
          isDrawerMode
          hasRequiredValues
          showModal={showEventPayment}
          setShowModal={setShowEventPayment}
          title={localize.register_payment}
          onClickToCancel={() => {
            setEventPaymentData(getClearEventPaymentModel());
            setShowEventPayment(false);
          }}
          onClickToSubmit={() => {
            UpdatePaymentDate();
            setShowEventPayment(false);
          }}
          validators={disableSaveChangesForPaymentData()}
          Component={
            <PaymentReport
              paymentModel={eventPaymentData}
              setPaymentModel={setEventPaymentData}
            />
          }
        />
      )}

      {showEventBilling && (
        <ModalBackground
          isDrawerMode
          hasRequiredValues
          showModal={showEventBilling}
          setShowModal={setShowEventBilling}
          title={localize.register_bill}
          onClickToSubmit={() => {
            RegisterBilling();
            setShowEventBilling(false);
          }}
          validators={disableChangesForBilling()}
          Component={
            <AddBilling
              BillingModel={{
                ...eventBillingModel,
                Client: eventDetailData?.Client,
                ClientId: eventDetailData?.Client?.Id,
              }}
              setBillingModel={setEventBillingModel}
              billClient={eventDetailData?.Client}
            />
          }
        />
      )}

      {showEventSummary && (
        <ModalBackground
          showModal={showEventSummary}
          setShowModal={setShowEventSummary}
          title={localize.event_summary}
          onClickToSubmit={() => {
            setShowEventSummary(false);
          }}
          hideCancelButton
          okButtonText={localize.ok}
          Component={<EventSummary eventInfo={eventDetailData} />}
        />
      )}

      {showModalAfterEventCreation && (
        <ModalBackground
          showModal={showModalAfterEventCreation}
          setShowModal={setShowModalAfterEventCreation}
          title={localize.new_event}
          onClickToSubmit={() => {
            window.open(`/events/detail/${newEventId}`, "_blank");
            setShowModalAfterEventCreation(false);
          }}
          onClickToCancel={() => {
            setShowModalAfterEventCreation(false);
          }}
          okButtonText={localize.open}
          cancelButtonText={localize.ignore}
          Component={<Typography>{localize.new_visit_generated}</Typography>}
        />
      )}

      {showCreateVisit && (
        <ModalBackground
          isDrawerMode
          hasRequiredValues
          showModal={showCreateVisit}
          setShowModal={setShowCreateVisit}
          title={`${localize.new_event} ${localize.related_to} ${eventDetailData?.Code}`}
          onClickToSubmit={async () => {
            await handleCreateRequest(eventModel);
            setShowCreateVisit(false);
            setCity(null);
            setCityFilterCode(null);
            setMunicipalityFilterCode(null);
            setEventModel(getClearEventModel());
          }}
          onClickToCancel={() => {
            setShowCreateVisit(false);
            setCity(null);
            setCityFilterCode(null);
            setMunicipalityFilterCode(null);
            setEventModel(getClearEventModel());
          }}
          Component={<AddOrEditEvent />}
          validators={disableChangesForEvent()}
        />
      )}

      {showDeleteSectionModal && (
        <DeleteConfirmationMessage
          entityName={sectionModel?.Name}
          entityType={localize.section}
          onClickForCancel={() => {
            toggleVisibleModalConfirm();
            setSectionModel(null);
            setShowDeleteSectionModal(false);
          }}
          onClickForConfirm={() => {
            toggleVisibleModalConfirm();
            deleteSection(sectionModel);
            setSectionModel(null);
            setShowDeleteSectionModal(false);
          }}
        />
      )}

      {showDeleteModal && (
        <DeleteConfirmationMessage
          entityName={evidenceModelForEdition?.Name}
          entityType={localize.evidence}
          onClickForCancel={() => {
            toggleVisibleModalConfirm();
            setEvidenceModelForEdition(null);
            setShowDeleteModal(false);
          }}
          onClickForConfirm={() => {
            toggleVisibleModalConfirm();
            deleteEvidence(evidenceModelForEdition);
            setEvidenceModelForEdition(null);
            setShowDeleteModal(false);
          }}
        />
      )}

      {showUploadingImage && (
        <ModalBackground
          showModal={showUploadingImage}
          setShowModal={setShowUploadingImage}
          title={localize.app_name}
          hideCancelButton
          hideSubmitButton
          Component={
            <div
              style={{ width: "300px", height: "60px" }}
              className="flex gap-2 items-center"
            >
              <Typography>{`${localize.processing}, ${localize.please_wait}...`}</Typography>
              <CircularProgress />
            </div>
          }
        />
      )}

      {showEvidenceModal && (
        <ModalBackground
          isDrawerMode
          hasRequiredValues={
            !selectedFilesForEvidences || selectedFilesForEvidences.length === 0
          }
          showModal={showEvidenceModal}
          setShowModal={setShowEvidenceModal}
          title={localize.evidences}
          okButtonText={
            selectedFilesForEvidences && selectedFilesForEvidences.length > 0
              ? localize.upload_files
              : localize.save_changes
          }
          cancelButtonText={
            selectedFilesForEvidences &&
            selectedFilesForEvidences.length > 0 &&
            isUploadingMultipleEvidences
              ? localize.close
              : localize.cancel
          }
          hideCancelButton={isExecutingMultipleEvidencesUpload}
          hideSubmitButton={isUploadingMultipleEvidences}
          validators={disableSaveChangesForEvidence()}
          onClickToSubmit={() => {
            if (
              selectedFilesForEvidences &&
              selectedFilesForEvidences.length > 0
            ) {
              uploadMultipleEvidences();
              setUpdateEvidenceFile(false);
            } else {
              handleCreateOrUpdateEvidence(evidenceModelForEdition);
              setEvidenceModelForEdition(null);
              setShowEvidenceModal(false);
              setUpdateEvidenceFile(false);
            }
          }}
          onClickToCancel={() => {
            setEvidenceModelForEdition(null);
            setShowEvidenceModal(false);
            setUpdateEvidenceFile(false);

            if (
              selectedFilesForEvidences &&
              selectedFilesForEvidences.length > 0
            ) {
              validateOperationResultForFileUpload(
                {
                  Ok: true,
                },
                true,
              );
              setIsUploadingMultipleEvidences(false);
            }
          }}
          Component={
            <AddOrEditEvidence
              evidenceModel={evidenceModelForEdition}
              setEvidenceModel={setEvidenceModelForEdition}
              updateFile={updateEvidenceFile}
              setUpdateFile={setUpdateEvidenceFile}
              selectedFiles={selectedFilesForEvidences}
              setSelectedFiles={setSelectedFilesForEvidences}
              isUploading={isUploadingMultipleEvidences}
            />
          }
        />
      )}

      {showGenerateInformModal && (
        <ReportSetup
          locationHref={window.location.href}
          showGenerateInformModal={showGenerateInformModal}
          setShowGenerateInformModal={setShowGenerateInformModal}
          invisibleEvidences={notVisibleEvidences}
        />
      )}

      {showAddEventReview && (
        <ModalBackground
          isDrawerMode
          hasRequiredValues
          showModal={showAddEventReview}
          setShowModal={setShowAddEventReview}
          title={localize.add_technical_concept}
          onClickToSubmit={() => {
            createEventReview();
          }}
          onClickToCancel={() => {
            setShowAddEventReview(false);
            setEventReview(null);
          }}
          Component={
            <AddEventReview
              model={eventReview}
              setModel={setEventReview}
              evidences={evidenceData?.Data}
              notes={eventReviewData?.Data}
            />
          }
          validators={disableSaveChangesForEventReview()}
        />
      )}

      {showFinishReview && (
        <ModalBackground
          isDrawerMode
          hasRequiredValues
          showModal={showFinishReview}
          setShowModal={setShowFinishReview}
          title={localize.finish_review}
          onClickToSubmit={() => {
            finishReview();
          }}
          onClickToCancel={() => {
            setShowFinishReview(false);
          }}
          Component={
            <FinishEventForm
              finishReview={finishEventReview}
              setFinishReview={setFinishEventReview}
            />
          }
          validators={disableSaveChangesForFinishReview()}
        />
      )}

      {showPaymentToTechnicianModal && (
        <ModalBackground
          isDrawerMode
          hasRequiredValues
          showModal={showPaymentToTechnicianModal}
          setShowModal={setShowPaymentToTechnicianModal}
          title={
            paymentToTechnician?.Id > 0
              ? localize.payment_to_technician
              : localize.register_payment_to_technician
          }
          onClickToSubmit={() => {
            RegisterPaymentToTechnician();
            setShowPaymentToTechnicianModal(false);
          }}
          onClickToCancel={() => {
            setShowPaymentToTechnicianModal(false);
          }}
          Component={
            <PaymentToTechnician
              eventData={eventDetailData}
              paymentData={paymentToTechnician}
              setPaymentData={setPaymentToTechnician}
            />
          }
          validators={disableSaveChangesForPaymentToTechnician()}
        />
      )}

      {showAddStatusChangeModal && (
        <ModalBackground
          isDrawerMode
          hasRequiredValues
          showModal={showAddStatusChangeModal}
          setShowModal={setShowAddStatusChangeModal}
          title={localize.status_change}
          onClickToSubmit={async () => {
            await createStatusChange();
          }}
          onClickToCancel={() => {
            setShowAddStatusChangeModal(false);
            setStatusChangeEventModel(getClearStatusChangeEventModel());
          }}
          Component={
            <AddStatusChange
              currentStatus={eventDetailData?.CurrentStatus}
              eventData={eventDetailData}
              newStatus={newStatus}
              setNewStatus={setNewStatus}
            />
          }
          validators={disableSaveChangesForStatusChange()}
        />
      )}

      {showErrorModal && (
        <ErrorMessage
          message={errorMessage}
          setTitle={setErrorMessageTitle}
          title={errorMessageTitle ?? localize.error_unexpected}
          showModal={showErrorModal}
          setShowModal={setShowErrorModal}
        />
      )}

      {showSupplySearchModal && (
        <SupplySearch
          setResultList={setSearchSupplyList}
          showSearch={showSupplySearchModal}
          setShowSearch={setShowSupplySearchModal}
          singleSearch
          warehouse={eventDetailData?.PersonalAssigned?.Warehouse}
          setUsedWarehouse={setUsedWarehouse}
        />
      )}

      {showAddSupplyModal && (
        <ModalBackground
          isDrawerMode
          hasRequiredValues
          title={localize.assign_quantity}
          validators={!quantityForSupply || quantityForSupply === 0}
          showModal={showAddSupplyModal}
          setShowModal={setShowAddSupplyModal}
          okButtonText={localize.accept}
          cancelButtonText={localize.cancel}
          onClickToSubmit={() => {
            setSupplyUsageModel({
              ...supplyUsageModel,
              Supply: { ...searchSupplyList[0] },
              SupplyId: searchSupplyList[0].Id,
              Quantity: quantityForSupply,
              Observation: detailSupplyUsageObservation,
            });
            createSupply({
              ...supplyUsageModel,
              Supply: { ...searchSupplyList[0] },
              SupplyId: searchSupplyList[0].Id,
              Quantity: quantityForSupply,
              Observation: detailSupplyUsageObservation,
            });
            setShowAddSupplyModal(false);
          }}
          onClickToCancel={() => {
            setSearchSupplyList([]);
            setQuantityForSupply(1);
            setSupplyUsageModel(getClearSupplyUsageModel());
            setShowAddSupplyModal(false);
          }}
          Component={
            <Box className="flex flex-col gap-3 my-2" sx={{ width: "100%" }}>
              <Alert severity="info" className="w-full">
                <label className="text-xs">
                  {localize.info_supply_adding_to_event}
                </label>
              </Alert>

              <Box className="flex w-full justify-between">
                <Box
                  className="two_columns_grid"
                  sx={{ minWidth: 0, overflow: "hidden" }}
                >
                  <label className="field_title_text">
                    <b>{`${localize.code}:`}</b>
                  </label>
                  <label className="field_title_text">
                    {searchSupplyList[0].Code}
                  </label>
                  <label className="field_title_text">
                    <b>{`${localize.name}:`}</b>
                  </label>
                  <label className="field_title_text">
                    {searchSupplyList[0].Name}
                  </label>
                  <label className="field_title_text">
                    <b>{`${localize.quantity}:`}</b>
                  </label>
                  <label className="field_title_text">
                    {`${searchSupplyList[0]?.Quantity} ${
                      searchSupplyList[0]?.Unit?.Name ?? ""
                    } ${
                      searchSupplyList[0]?.Unit?.Symbol
                        ? `(${searchSupplyList[0]?.Unit?.Symbol})`
                        : ""
                    }`}
                  </label>
                </Box>
              </Box>

              <Divider />

              {searchSupplyList[0].Quantity <= 0 && (
                <Alert severity="warning" className="w-full">
                  <label className="text-xs">
                    {localize.there_is_no_supplies_on_warehouse}
                  </label>
                </Alert>
              )}

              <Box className="w-full">
                <TextField
                  type="number"
                  InputLabelProps={getInputLabelProps()}
                  inputProps={getInputProps()}
                  value={quantityForSupply}
                  onChange={(e) => {
                    setQuantityForSupply(
                      e.target.value
                        ? e.target.value <= 0
                          ? 1
                          : e.target.value
                        : 1,
                    );
                  }}
                  size="small"
                  id="Quantity"
                  name="Quantity"
                  variant="outlined"
                  fullWidth
                  label={localize.quantity}
                />
              </Box>

              <FormControl fullWidth>
                <TextField
                  InputLabelProps={getInputLabelProps()}
                  inputProps={{
                    style: {
                      fontSize: "0.8em",
                    },
                    maxLength: maximumCharactersForSupplyUsageDescription,
                  }}
                  size="small"
                  fullWidth
                  multiline
                  rows={3}
                  id="outlined-basic"
                  name="Observation"
                  label={localize.observations}
                  variant="outlined"
                  onChange={handleChangeSupplyUsageDetailObservation}
                  value={detailSupplyUsageObservation}
                  helperText={`${detailSupplyUsageObservationCount}/${maximumCharactersForSupplyUsageDescription}`}
                />
              </FormControl>
            </Box>
          }
        />
      )}

      {showGalleryModal && (
        <ModalBackground
          okButtonAlwaysAvailable
          showModal={showGalleryModal}
          setShowModal={setShowModalGallery}
          title={`${localize.evidences} - ${localize.service_order}: ${eventDetailData.Code}`}
          onClickToSubmit={async () => {
            window.open(
              `${window.location.href}/evidence/${selectedEvidence.Id}/${selectedEvidence.EvidenceType}`,
              "_blank",
            );
          }}
          okButtonText={localize.show_full_screen}
          cancelButtonText={localize.close}
          onClickToCancel={() => {
            setShowModalGallery(false);
          }}
          Component={
            <EvidenceViewer
              setSelectedEvidence={setSelectedEvidence}
              evidences={evidenceData?.Data?.filter(
                (x) => x.EvidenceType !== 5 && x.EvidenceType !== 6,
              )}
              eventId={eventDetailData?.Id}
              notes={eventReviewData?.Data}
              selectedEvidenceId={selectedEvidence?.Id}
            />
          }
        />
      )}

      {showAdditionalCostsModal && (
        <ModalBackground
          isDrawerMode
          hasRequiredValues
          showModal={showAdditionalCostsModal}
          setShowModal={setShowAdditionalCostsModal}
          title={
            assignAdditionalCostStatus
              ? localize.change_additional_cost_status
              : localize.add_additional_cost
          }
          onClickToCancel={() => {
            setAssignAdditionalCostStatus(false);
            setShowAdditionalCostsModal(false);
          }}
          onClickToSubmit={() => {
            if (assignAdditionalCostStatus) {
              handleUpdateAdditionalCost(additionalCostModel);
            } else {
              handleCreateAdditionalCost(additionalCostModel);
            }

            setAssignAdditionalCostStatus(false);
            setShowAdditionalCostsModal(false);
          }}
          Component={
            <div className="mb-4">
              <AddOrEditAdditionalCost
                model={additionalCostModel}
                setModel={setAdditionalCostModel}
                setStatus={assignAdditionalCostStatus}
              />
            </div>
          }
          validators={disableSaveChangesForAdditionalCost()}
        />
      )}

      {showAssignEventModal && (
        <ModalBackground
          isDrawerMode
          hasRequiredValues
          showModal={setShowAssignEventModal}
          setShowModal={setShowAssignEventModal}
          title={`${localize.assign_event} (${localize.code}: ${
            eventModel?.Code ?? `${localize.app_name}-${eventModel.Id}`
          })`}
          onClickToSubmit={async () => {
            await handleAssignRequest(eventModel);
            setShowAssignEventModal(false);
          }}
          onClickToCancel={() => {
            setShowAssignEventModal(false);
          }}
          Component={<AssignEvent />}
          validators={disableSaveChangesForEventAssignment()}
        />
      )}

      <Card variant="outlined" style={{ padding: "16px", overflow: "hidden" }}>
        <Box className="flex flex-col gap-4">
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "stretch", sm: "center" },
              gap: 2,
            }}
          >
            <Box
              className="two_columns_grid"
              sx={{ minWidth: 0, overflow: "hidden" }}
            >
              <label className="field_title_text">
                <b>{`${localize.event}: `}</b>
              </label>
              <label className="field_title_text field_value_wrap">{`${id}`}</label>
              {eventDetailData?.ProceedingInfo?.Name && (
                <>
                  <label className="field_title_text">
                    <b>{localize.proceeding}:</b>
                  </label>
                  <label className="field_title_text field_value_wrap">{`${
                    eventDetailData?.ProceedingInfo?.Name ?? localize.no_data
                  }`}</label>
                </>
              )}
              <label className="field_title_text">
                <b>{localize.code}:</b>
              </label>
              <label className="field_title_text field_value_wrap">
                {!eventDetailData ? localize.no_data : getCode()}
              </label>
              <label className="field_title_text">
                <b>{localize.workflow}: </b>
              </label>
              <label className="field_title_text field_value_wrap">
                {eventDetailData?.EventType?.WorkFlow
                  ? eventDetailData?.EventType?.WorkFlow?.Name
                  : localize.no_data}
              </label>
              {eventDetailData?.ParentEventCode &&
                eventDetailData?.ParentEventCode.length > 0 &&
                eventDetailData?.ParentEventId &&
                eventDetailData?.ParentEventId.length > 0 && (
                  <>
                    <label className="field_title_text">
                      <b>{`${localize.event} ${localize.related_to}`}: </b>
                    </label>
                    <label className="field_title_text field_value_wrap">
                      <Link
                        color="primary"
                        underline="always"
                        href="#"
                        onClick={() => {
                          window.open(
                            `/events/detail/${eventDetailData.ParentEventId}`,
                            "_blank",
                          );
                        }}
                      >{`${eventDetailData.ParentEventCode}`}</Link>
                    </label>
                  </>
                )}
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
                justifyContent: "evenly",
              }}
            >
              <Box className="title_status_vertical">
                <label className="field_title_text">
                  <b>{localize.event_type}:</b>
                </label>
                <ExecutionStatusField
                  executionStatus={eventDetailData?.EventType}
                />
              </Box>

              <Box className="title_status_vertical">
                <label className="field_title_text">
                  <b>{localize.execution_status}: </b>
                </label>
                <ExecutionStatusField
                  executionStatus={eventDetailData?.CurrentStatus}
                />
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            width: "100%",
            mt: 1,
            gap: 2,
          }}
        >
          <Alert
            className="field_title_text"
            style={{ width: "100%" }}
            severity={getAlertTypeFromOperationalStatusId(
              eventDetailData?.OperationalStatus,
            )}
          >
            <label className="text-xs">
              {eventDetailData?.OperationalStatus === 0
                ? localize.order_has_been.replaceAll(
                    "%s1",
                    `'${getOperationalStatusNameFromId(
                      eventDetailData?.OperationalStatus,
                    )}', ${localize.motivation}: ${
                      eventDetailData?.FinishObservation
                    }`,
                  )
                : localize.order_has_been.replaceAll(
                    "%s1",
                    `'${getOperationalStatusNameFromId(
                      eventDetailData?.OperationalStatus,
                    )}'.`,
                  )}
            </label>
          </Alert>

          <ButtonGroup
            size="small"
            ref={anchorOptionsRef}
            variant="contained"
            sx={{
              backgroundColor: "#10366E !important;",
              alignSelf: { xs: "flex-start", sm: "auto" },
            }}
          >
            <Button
              size="small"
              sx={{
                backgroundColor: "#10366E !important;",
              }}
              disabled={getEventOptions[selectedOptionIndex].disabled}
              onClick={handleSelectedOptionClick}
            >
              {getEventOptions[selectedOptionIndex].title}
            </Button>
            <Button
              size="small"
              sx={{
                backgroundColor: "#10366E !important;",
              }}
              aria-controls={openEventOptions ? "split-button-menu" : undefined}
              aria-expanded={openEventOptions ? "true" : undefined}
              aria-haspopup="menu"
              onClick={handleEventOptionsToggle}
            >
              <ArrowDropDown />
            </Button>
          </ButtonGroup>

          <Popper
            sx={{ zIndex: 10 }}
            open={openEventOptions}
            anchorEl={anchorOptionsRef.current}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleEventOptionsClose}>
                    <MenuList id="split-button-menu" autoFocusItem>
                      {getEventOptions.map((option, index) => (
                        <MenuItem
                          key={option.title}
                          selected={index === selectedOptionIndex}
                          onClick={(event) =>
                            handleEventOptionsClick(event, index)
                          }
                          disabled={option.disabled}
                          sx={{ color: option.color ?? "#000000DE" }}
                        >
                          {option.title}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      </Card>

      {isMobile ? (
        <Box sx={{ mt: "20px" }}>
          <ExpandableView
            defaultExpandedIndexes={[
              Math.max(
                0,
                getTabPages().findIndex((p) => p.Id === selectedTabId),
              ),
            ]}
            components={getTabPages().map((p) => ({
              Name: p.Name,
              Component: (
                <TabContext value={String(p.Id)}>
                  {renderEventTabPanels()}
                </TabContext>
              ),
            }))}
          />
        </Box>
      ) : (
        <TabContext value={selectedTab}>
          <Box
            className="my-2"
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ScrollablePageTab
              selectedPage={selectedTabId}
              setSelectedPage={changeTab}
              noMarginTop
              dynamicFormPages={getTabPages()}
              maxWidthValue={"90%"}
              reportTabId
            />
          </Box>
          {renderEventTabPanels()}
        </TabContext>
      )}
    </div>
  );
}
